 /**
 * This file is generated by running "node packages/generate-emoji-data/build.js"
 */

export type EmojiCategory = 'people' | 'animals_and_nature' | 'food_and_drink' | 'travel_and_places' | 'activity' | 'objects' | 'symbols' | 'flags';

export const skinToneModifiers = [
  "🏻",
  "🏼",
  "🏽",
  "🏾",
  "🏿"
];

export interface Emoji {
  char: string;
  name: string;
  altNames: string[];
  keywords: string[];
  category: EmojiCategory;
  fitzpatrickScale: boolean;
}

const emojis: Emoji[] = [
  {
    "char": "😀",
    "name": "grinning",
    "altNames": [],
    "keywords": [
      "face",
      "grinning face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😃",
    "name": "smiley",
    "altNames": [],
    "keywords": [
      "face",
      "grinning face with big eyes",
      "mouth",
      "open"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😄",
    "name": "smile",
    "altNames": [],
    "keywords": [
      "eye",
      "face",
      "grinning face with smiling eyes",
      "mouth",
      "open"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😁",
    "name": "grin",
    "altNames": [],
    "keywords": [
      "beaming face with smiling eyes",
      "eye",
      "face",
      "smile"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😆",
    "name": "laughing",
    "altNames": [
      "satisfied"
    ],
    "keywords": [
      "face",
      "grinning squinting face",
      "mouth",
      "smile"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😅",
    "name": "sweat_smile",
    "altNames": [],
    "keywords": [
      "cold",
      "face",
      "grinning face with sweat",
      "open"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤣",
    "name": "rolling_on_the_floor_laughing",
    "altNames": [],
    "keywords": [
      "face",
      "rofl",
      "rotfl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😂",
    "name": "joy",
    "altNames": [],
    "keywords": [
      "face",
      "face with tears of joy",
      "laugh",
      "tear"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙂",
    "name": "slightly_smiling_face",
    "altNames": [],
    "keywords": [
      "smile"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙃",
    "name": "upside_down_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😉",
    "name": "wink",
    "altNames": [],
    "keywords": [
      "face",
      "winking face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😊",
    "name": "blush",
    "altNames": [],
    "keywords": [
      "eye",
      "face",
      "smile",
      "smiling face with smiling eyes"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😇",
    "name": "innocent",
    "altNames": [],
    "keywords": [
      "angel",
      "face",
      "fantasy",
      "halo",
      "smiling face with halo"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥰",
    "name": "smiling_face_with_3_hearts",
    "altNames": [],
    "keywords": [
      "adore",
      "crush",
      "in love",
      "smiling face with hearts"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😍",
    "name": "heart_eyes",
    "altNames": [],
    "keywords": [
      "face",
      "love",
      "smile",
      "smiling face with heart-eyes"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤩",
    "name": "star-struck",
    "altNames": [
      "grinning_face_with_star_eyes"
    ],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😘",
    "name": "kissing_heart",
    "altNames": [],
    "keywords": [
      "face",
      "face blowing a kiss"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😗",
    "name": "kissing",
    "altNames": [],
    "keywords": [
      "face",
      "kissing face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😚",
    "name": "kissing_closed_eyes",
    "altNames": [],
    "keywords": [
      "face",
      "kissing face with closed eyes"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😙",
    "name": "kissing_smiling_eyes",
    "altNames": [],
    "keywords": [
      "face",
      "kissing face with smiling eyes",
      "smile"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😋",
    "name": "yum",
    "altNames": [],
    "keywords": [
      "delicious",
      "face",
      "face savoring food",
      "savouring",
      "smile"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😛",
    "name": "stuck_out_tongue",
    "altNames": [],
    "keywords": [
      "face",
      "face with tongue"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😜",
    "name": "stuck_out_tongue_winking_eye",
    "altNames": [],
    "keywords": [
      "face",
      "joke",
      "winking face with tongue"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤪",
    "name": "zany_face",
    "altNames": [
      "grinning_face_with_one_large_and_one_small_eye"
    ],
    "keywords": [
      "goofy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😝",
    "name": "stuck_out_tongue_closed_eyes",
    "altNames": [],
    "keywords": [
      "face",
      "horrible",
      "squinting face with tongue",
      "taste"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤑",
    "name": "money_mouth_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤗",
    "name": "hugging_face",
    "altNames": [],
    "keywords": [
      "open hands",
      "smiling face",
      "smiling face with open hands"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤭",
    "name": "face_with_hand_over_mouth",
    "altNames": [
      "smiling_face_with_smiling_eyes_and_hand_covering_mouth"
    ],
    "keywords": [
      "whoops"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤫",
    "name": "shushing_face",
    "altNames": [
      "face_with_finger_covering_closed_lips"
    ],
    "keywords": [
      "quiet"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤔",
    "name": "thinking_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤐",
    "name": "zipper_mouth_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤨",
    "name": "face_with_raised_eyebrow",
    "altNames": [
      "face_with_one_eyebrow_raised"
    ],
    "keywords": [
      "distrust",
      "skeptic"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😐",
    "name": "neutral_face",
    "altNames": [],
    "keywords": [
      "deadpan",
      "meh"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😑",
    "name": "expressionless",
    "altNames": [],
    "keywords": [
      "face",
      "inexpressive",
      "meh",
      "unexpressive"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😶",
    "name": "no_mouth",
    "altNames": [],
    "keywords": [
      "face",
      "face without mouth",
      "quiet",
      "silent"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😏",
    "name": "smirk",
    "altNames": [],
    "keywords": [
      "face",
      "smirking face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😒",
    "name": "unamused",
    "altNames": [],
    "keywords": [
      "face",
      "unhappy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙄",
    "name": "face_with_rolling_eyes",
    "altNames": [],
    "keywords": [
      "eyeroll"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😬",
    "name": "grimacing",
    "altNames": [],
    "keywords": [
      "face",
      "grimace",
      "grimacing face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤥",
    "name": "lying_face",
    "altNames": [],
    "keywords": [
      "lie",
      "pinocchio"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😌",
    "name": "relieved",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😔",
    "name": "pensive",
    "altNames": [],
    "keywords": [
      "dejected",
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😪",
    "name": "sleepy",
    "altNames": [],
    "keywords": [
      "face",
      "good night",
      "sleepy face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤤",
    "name": "drooling_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😴",
    "name": "sleeping",
    "altNames": [],
    "keywords": [
      "face",
      "good night",
      "sleeping face",
      "zzz"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😷",
    "name": "mask",
    "altNames": [],
    "keywords": [
      "cold",
      "doctor",
      "face",
      "face with medical mask",
      "sick"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤒",
    "name": "face_with_thermometer",
    "altNames": [],
    "keywords": [
      "ill",
      "sick"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤕",
    "name": "face_with_head_bandage",
    "altNames": [],
    "keywords": [
      "hurt",
      "injury"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤢",
    "name": "nauseated_face",
    "altNames": [],
    "keywords": [
      "vomit"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤮",
    "name": "face_vomiting",
    "altNames": [
      "face_with_open_mouth_vomiting"
    ],
    "keywords": [
      "puke",
      "sick"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤧",
    "name": "sneezing_face",
    "altNames": [],
    "keywords": [
      "gesundheit",
      "sneeze"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥵",
    "name": "hot_face",
    "altNames": [],
    "keywords": [
      "feverish",
      "heat stroke",
      "red-faced",
      "sweating"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥶",
    "name": "cold_face",
    "altNames": [],
    "keywords": [
      "blue-faced",
      "freezing",
      "frostbite",
      "icicles"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥴",
    "name": "woozy_face",
    "altNames": [],
    "keywords": [
      "dizzy",
      "intoxicated",
      "tipsy",
      "uneven eyes",
      "wavy mouth"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😵",
    "name": "dizzy_face",
    "altNames": [],
    "keywords": [
      "crossed-out eyes",
      "dead",
      "face with crossed-out eyes",
      "knocked out"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤯",
    "name": "exploding_head",
    "altNames": [
      "shocked_face_with_exploding_head"
    ],
    "keywords": [
      "mind blown"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤠",
    "name": "face_with_cowboy_hat",
    "altNames": [],
    "keywords": [
      "cowgirl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥳",
    "name": "partying_face",
    "altNames": [],
    "keywords": [
      "celebration",
      "hat",
      "horn"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😎",
    "name": "sunglasses",
    "altNames": [],
    "keywords": [
      "bright",
      "cool",
      "face",
      "smiling face with sunglasses"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤓",
    "name": "nerd_face",
    "altNames": [],
    "keywords": [
      "geek"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧐",
    "name": "face_with_monocle",
    "altNames": [],
    "keywords": [
      "stuffy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😕",
    "name": "confused",
    "altNames": [],
    "keywords": [
      "face",
      "meh"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😟",
    "name": "worried",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙁",
    "name": "slightly_frowning_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😮",
    "name": "open_mouth",
    "altNames": [],
    "keywords": [
      "face",
      "face with open mouth",
      "sympathy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😯",
    "name": "hushed",
    "altNames": [],
    "keywords": [
      "face",
      "stunned",
      "surprised"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😲",
    "name": "astonished",
    "altNames": [],
    "keywords": [
      "face",
      "shocked",
      "totally"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😳",
    "name": "flushed",
    "altNames": [],
    "keywords": [
      "dazed",
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥺",
    "name": "pleading_face",
    "altNames": [],
    "keywords": [
      "begging",
      "mercy",
      "puppy eyes"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😦",
    "name": "frowning",
    "altNames": [],
    "keywords": [
      "face",
      "frowning face with open mouth",
      "mouth",
      "open"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😧",
    "name": "anguished",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😨",
    "name": "fearful",
    "altNames": [],
    "keywords": [
      "face",
      "scared"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😰",
    "name": "cold_sweat",
    "altNames": [],
    "keywords": [
      "anxious face with sweat",
      "blue",
      "face",
      "rushed"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😥",
    "name": "disappointed_relieved",
    "altNames": [],
    "keywords": [
      "face",
      "sad but relieved face",
      "whew"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😢",
    "name": "cry",
    "altNames": [],
    "keywords": [
      "crying face",
      "face",
      "sad",
      "tear"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😭",
    "name": "sob",
    "altNames": [],
    "keywords": [
      "cry",
      "face",
      "loudly crying face",
      "sad",
      "tear"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😱",
    "name": "scream",
    "altNames": [],
    "keywords": [
      "face",
      "face screaming in fear",
      "fear",
      "munch",
      "scared"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😖",
    "name": "confounded",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😣",
    "name": "persevere",
    "altNames": [],
    "keywords": [
      "face",
      "persevering face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😞",
    "name": "disappointed",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😓",
    "name": "sweat",
    "altNames": [],
    "keywords": [
      "cold",
      "downcast face with sweat",
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😩",
    "name": "weary",
    "altNames": [],
    "keywords": [
      "face",
      "tired"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😫",
    "name": "tired_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🥱",
    "name": "yawning_face",
    "altNames": [],
    "keywords": [
      "bored",
      "tired"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😤",
    "name": "triumph",
    "altNames": [],
    "keywords": [
      "face",
      "face with steam from nose",
      "won"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😡",
    "name": "rage",
    "altNames": [],
    "keywords": [
      "angry",
      "enraged",
      "face",
      "mad",
      "pouting",
      "red"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😠",
    "name": "angry",
    "altNames": [],
    "keywords": [
      "anger",
      "face",
      "mad"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤬",
    "name": "face_with_symbols_on_mouth",
    "altNames": [
      "serious_face_with_symbols_covering_mouth"
    ],
    "keywords": [
      "swearing"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😈",
    "name": "smiling_imp",
    "altNames": [],
    "keywords": [
      "face",
      "fairy tale",
      "fantasy",
      "horns",
      "smile",
      "smiling face with horns"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👿",
    "name": "imp",
    "altNames": [],
    "keywords": [
      "angry face with horns",
      "demon",
      "devil",
      "face",
      "fantasy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💀",
    "name": "skull",
    "altNames": [],
    "keywords": [
      "death",
      "face",
      "fairy tale",
      "monster"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "☠️",
    "name": "skull_and_crossbones",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💩",
    "name": "hankey",
    "altNames": [
      "poop",
      "shit"
    ],
    "keywords": [
      "dung",
      "face",
      "monster",
      "pile of poo"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤡",
    "name": "clown_face",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👹",
    "name": "japanese_ogre",
    "altNames": [],
    "keywords": [
      "creature",
      "face",
      "fairy tale",
      "fantasy",
      "monster"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👺",
    "name": "japanese_goblin",
    "altNames": [],
    "keywords": [
      "creature",
      "face",
      "fairy tale",
      "fantasy",
      "monster"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👻",
    "name": "ghost",
    "altNames": [],
    "keywords": [
      "creature",
      "face",
      "fairy tale",
      "fantasy",
      "monster"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👽",
    "name": "alien",
    "altNames": [],
    "keywords": [
      "creature",
      "extraterrestrial",
      "face",
      "fantasy",
      "ufo"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👾",
    "name": "space_invader",
    "altNames": [],
    "keywords": [
      "alien",
      "creature",
      "extraterrestrial",
      "face",
      "monster",
      "ufo"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤖",
    "name": "robot_face",
    "altNames": [],
    "keywords": [
      "monster"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😺",
    "name": "smiley_cat",
    "altNames": [],
    "keywords": [
      "face",
      "grinning",
      "mouth",
      "open"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😸",
    "name": "smile_cat",
    "altNames": [],
    "keywords": [
      "eye",
      "face",
      "grin",
      "grinning cat with smiling eyes"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😹",
    "name": "joy_cat",
    "altNames": [],
    "keywords": [
      "cat with tears of joy",
      "face",
      "tear"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😻",
    "name": "heart_eyes_cat",
    "altNames": [],
    "keywords": [
      "face",
      "love",
      "smile",
      "smiling cat with heart-eyes"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😼",
    "name": "smirk_cat",
    "altNames": [],
    "keywords": [
      "cat with wry smile",
      "face",
      "ironic",
      "smile",
      "wry"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😽",
    "name": "kissing_cat",
    "altNames": [],
    "keywords": [
      "eye",
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙀",
    "name": "scream_cat",
    "altNames": [],
    "keywords": [
      "face",
      "oh",
      "surprised",
      "weary"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😿",
    "name": "crying_cat_face",
    "altNames": [],
    "keywords": [
      "sad",
      "tear"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "😾",
    "name": "pouting_cat",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙈",
    "name": "see_no_evil",
    "altNames": [],
    "keywords": [
      "face",
      "forbidden",
      "monkey",
      "see-no-evil monkey"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙉",
    "name": "hear_no_evil",
    "altNames": [],
    "keywords": [
      "face",
      "forbidden",
      "hear-no-evil monkey",
      "monkey"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🙊",
    "name": "speak_no_evil",
    "altNames": [],
    "keywords": [
      "face",
      "forbidden",
      "monkey",
      "speak-no-evil monkey"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💌",
    "name": "love_letter",
    "altNames": [],
    "keywords": [
      "heart",
      "mail"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💘",
    "name": "cupid",
    "altNames": [],
    "keywords": [
      "arrow",
      "heart with arrow"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💝",
    "name": "gift_heart",
    "altNames": [],
    "keywords": [
      "heart with ribbon",
      "ribbon",
      "valentine"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💖",
    "name": "sparkling_heart",
    "altNames": [],
    "keywords": [
      "excited",
      "sparkle"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💗",
    "name": "heartpulse",
    "altNames": [],
    "keywords": [
      "excited",
      "growing",
      "growing heart",
      "nervous"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💓",
    "name": "heartbeat",
    "altNames": [],
    "keywords": [
      "beating",
      "beating heart",
      "pulsating"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💞",
    "name": "revolving_hearts",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💕",
    "name": "two_hearts",
    "altNames": [],
    "keywords": [
      "love"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💟",
    "name": "heart_decoration",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "❣️",
    "name": "heavy_heart_exclamation_mark_ornament",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💔",
    "name": "broken_heart",
    "altNames": [],
    "keywords": [
      "break"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "❤️",
    "name": "heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧡",
    "name": "orange_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💛",
    "name": "yellow_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💚",
    "name": "green_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💙",
    "name": "blue_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💜",
    "name": "purple_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤎",
    "name": "brown_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🖤",
    "name": "black_heart",
    "altNames": [],
    "keywords": [
      "evil",
      "wicked"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤍",
    "name": "white_heart",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💋",
    "name": "kiss",
    "altNames": [],
    "keywords": [
      "kiss mark",
      "lips"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💯",
    "name": "100",
    "altNames": [],
    "keywords": [
      "full",
      "hundred",
      "hundred points",
      "score"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💢",
    "name": "anger",
    "altNames": [],
    "keywords": [
      "anger symbol",
      "angry",
      "comic",
      "mad"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💥",
    "name": "boom",
    "altNames": [
      "collision"
    ],
    "keywords": [
      "comic"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💫",
    "name": "dizzy",
    "altNames": [],
    "keywords": [
      "comic",
      "star"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💦",
    "name": "sweat_drops",
    "altNames": [],
    "keywords": [
      "comic",
      "splashing",
      "sweat droplets"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💨",
    "name": "dash",
    "altNames": [],
    "keywords": [
      "comic",
      "dashing away",
      "running"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🕳️",
    "name": "hole",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💬",
    "name": "speech_balloon",
    "altNames": [],
    "keywords": [
      "bubble",
      "comic",
      "dialog"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👁️‍🗨️",
    "name": "eye-in-speech-bubble",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🗨️",
    "name": "left_speech_bubble",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🗯️",
    "name": "right_anger_bubble",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💭",
    "name": "thought_balloon",
    "altNames": [],
    "keywords": [
      "bubble",
      "comic"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💤",
    "name": "zzz",
    "altNames": [],
    "keywords": [
      "comic",
      "good night",
      "sleep"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👋",
    "name": "wave",
    "altNames": [],
    "keywords": [
      "hand",
      "waving"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤚",
    "name": "raised_back_of_hand",
    "altNames": [],
    "keywords": [
      "backhand"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🖐️",
    "name": "raised_hand_with_fingers_splayed",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "✋",
    "name": "hand",
    "altNames": [
      "raised_hand"
    ],
    "keywords": [
      "high 5",
      "high five"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🖖",
    "name": "spock-hand",
    "altNames": [],
    "keywords": [
      "finger",
      "vulcan",
      "vulcan salute"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👌",
    "name": "ok_hand",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤏",
    "name": "pinching_hand",
    "altNames": [],
    "keywords": [
      "small amount"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "✌️",
    "name": "v",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤞",
    "name": "crossed_fingers",
    "altNames": [
      "hand_with_index_and_middle_fingers_crossed"
    ],
    "keywords": [
      "luck"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤟",
    "name": "i_love_you_hand_sign",
    "altNames": [],
    "keywords": [
      "ily",
      "love-you gesture"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤘",
    "name": "the_horns",
    "altNames": [
      "sign_of_the_horns"
    ],
    "keywords": [
      "finger",
      "hand",
      "rock-on"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤙",
    "name": "call_me_hand",
    "altNames": [],
    "keywords": [
      "hang loose",
      "shaka"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👈",
    "name": "point_left",
    "altNames": [],
    "keywords": [
      "backhand",
      "backhand index pointing left",
      "finger",
      "hand",
      "index"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👉",
    "name": "point_right",
    "altNames": [],
    "keywords": [
      "backhand",
      "backhand index pointing right",
      "finger",
      "hand",
      "index"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👆",
    "name": "point_up_2",
    "altNames": [],
    "keywords": [
      "backhand",
      "backhand index pointing up",
      "finger",
      "hand"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🖕",
    "name": "middle_finger",
    "altNames": [
      "reversed_hand_with_middle_finger_extended"
    ],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👇",
    "name": "point_down",
    "altNames": [],
    "keywords": [
      "backhand",
      "backhand index pointing down",
      "finger",
      "hand"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "☝️",
    "name": "point_up",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👍",
    "name": "+1",
    "altNames": [
      "thumbsup"
    ],
    "keywords": [
      "hand"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👎",
    "name": "-1",
    "altNames": [
      "thumbsdown"
    ],
    "keywords": [
      "hand"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "✊",
    "name": "fist",
    "altNames": [],
    "keywords": [
      "clenched",
      "hand",
      "punch",
      "raised fist"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👊",
    "name": "facepunch",
    "altNames": [
      "punch"
    ],
    "keywords": [
      "clenched",
      "fist",
      "hand",
      "oncoming fist"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤛",
    "name": "left-facing_fist",
    "altNames": [],
    "keywords": [
      "leftwards"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤜",
    "name": "right-facing_fist",
    "altNames": [],
    "keywords": [
      "rightwards"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👏",
    "name": "clap",
    "altNames": [],
    "keywords": [
      "clapping hands",
      "hand"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙌",
    "name": "raised_hands",
    "altNames": [],
    "keywords": [
      "celebration",
      "gesture",
      "hooray",
      "raising hands"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👐",
    "name": "open_hands",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤲",
    "name": "palms_up_together",
    "altNames": [],
    "keywords": [
      "prayer"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤝",
    "name": "handshake",
    "altNames": [],
    "keywords": [
      "agreement",
      "meeting"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙏",
    "name": "pray",
    "altNames": [],
    "keywords": [
      "ask",
      "folded hands",
      "hand",
      "high 5",
      "high five",
      "please",
      "thanks"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "✍️",
    "name": "writing_hand",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💅",
    "name": "nail_care",
    "altNames": [],
    "keywords": [
      "cosmetics",
      "manicure",
      "polish"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤳",
    "name": "selfie",
    "altNames": [],
    "keywords": [
      "camera",
      "phone"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💪",
    "name": "muscle",
    "altNames": [],
    "keywords": [
      "biceps",
      "comic",
      "flex",
      "flexed biceps"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦾",
    "name": "mechanical_arm",
    "altNames": [],
    "keywords": [
      "accessibility",
      "prosthetic"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🦿",
    "name": "mechanical_leg",
    "altNames": [],
    "keywords": [
      "accessibility",
      "prosthetic"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🦵",
    "name": "leg",
    "altNames": [],
    "keywords": [
      "kick",
      "limb"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦶",
    "name": "foot",
    "altNames": [],
    "keywords": [
      "kick",
      "stomp"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👂",
    "name": "ear",
    "altNames": [],
    "keywords": [
      "body"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦻",
    "name": "ear_with_hearing_aid",
    "altNames": [],
    "keywords": [
      "accessibility",
      "hard of hearing"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👃",
    "name": "nose",
    "altNames": [],
    "keywords": [
      "body"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧠",
    "name": "brain",
    "altNames": [],
    "keywords": [
      "intelligent"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🦷",
    "name": "tooth",
    "altNames": [],
    "keywords": [
      "dentist"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🦴",
    "name": "bone",
    "altNames": [],
    "keywords": [
      "skeleton"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👀",
    "name": "eyes",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👁️",
    "name": "eye",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👅",
    "name": "tongue",
    "altNames": [],
    "keywords": [
      "body"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👄",
    "name": "lips",
    "altNames": [],
    "keywords": [
      "mouth"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👶",
    "name": "baby",
    "altNames": [],
    "keywords": [
      "young"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧒",
    "name": "child",
    "altNames": [],
    "keywords": [
      "gender-neutral",
      "unspecified gender",
      "young"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👦",
    "name": "boy",
    "altNames": [],
    "keywords": [
      "young"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👧",
    "name": "girl",
    "altNames": [],
    "keywords": [
      "virgo",
      "young",
      "zodiac"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧑",
    "name": "adult",
    "altNames": [],
    "keywords": [
      "gender-neutral",
      "person",
      "unspecified gender"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👱",
    "name": "person_with_blond_hair",
    "altNames": [],
    "keywords": [
      "blond-haired person",
      "person: blond hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨",
    "name": "man",
    "altNames": [],
    "keywords": [
      "adult"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧔",
    "name": "bearded_person",
    "altNames": [],
    "keywords": [
      "person: beard"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦰",
    "name": "red_haired_man",
    "altNames": [],
    "keywords": [
      "adult",
      "man: red hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦱",
    "name": "curly_haired_man",
    "altNames": [],
    "keywords": [
      "adult",
      "man: curly hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦳",
    "name": "white_haired_man",
    "altNames": [],
    "keywords": [
      "adult",
      "man: white hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦲",
    "name": "bald_man",
    "altNames": [],
    "keywords": [
      "adult",
      "man: bald"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩",
    "name": "woman",
    "altNames": [],
    "keywords": [
      "adult"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦰",
    "name": "red_haired_woman",
    "altNames": [],
    "keywords": [
      "adult",
      "woman: red hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦱",
    "name": "curly_haired_woman",
    "altNames": [],
    "keywords": [
      "adult",
      "woman: curly hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦳",
    "name": "white_haired_woman",
    "altNames": [],
    "keywords": [
      "adult",
      "woman: white hair"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦲",
    "name": "bald_woman",
    "altNames": [],
    "keywords": [
      "adult",
      "woman: bald"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👱‍♀️",
    "name": "blond-haired-woman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👱‍♂️",
    "name": "blond-haired-man",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧓",
    "name": "older_adult",
    "altNames": [],
    "keywords": [
      "gender-neutral",
      "older person",
      "unspecified gender"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👴",
    "name": "older_man",
    "altNames": [],
    "keywords": [
      "adult"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👵",
    "name": "older_woman",
    "altNames": [],
    "keywords": [
      "adult"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙍",
    "name": "person_frowning",
    "altNames": [],
    "keywords": [
      "gesture"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙍‍♂️",
    "name": "man-frowning",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙍‍♀️",
    "name": "woman-frowning",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙎",
    "name": "person_with_pouting_face",
    "altNames": [],
    "keywords": [
      "gesture",
      "person pouting"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙎‍♂️",
    "name": "man-pouting",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙎‍♀️",
    "name": "woman-pouting",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙅",
    "name": "no_good",
    "altNames": [],
    "keywords": [
      "forbidden",
      "gesture",
      "hand",
      "person gesturing no",
      "prohibited"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙅‍♂️",
    "name": "man-gesturing-no",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙅‍♀️",
    "name": "woman-gesturing-no",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙆",
    "name": "ok_woman",
    "altNames": [],
    "keywords": [
      "gesture",
      "hand",
      "person gesturing ok"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙆‍♂️",
    "name": "man-gesturing-ok",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙆‍♀️",
    "name": "woman-gesturing-ok",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💁",
    "name": "information_desk_person",
    "altNames": [],
    "keywords": [
      "hand",
      "help",
      "person tipping hand",
      "sassy",
      "tipping"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💁‍♂️",
    "name": "man-tipping-hand",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💁‍♀️",
    "name": "woman-tipping-hand",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙋",
    "name": "raising_hand",
    "altNames": [],
    "keywords": [
      "gesture",
      "happy",
      "person raising hand",
      "raised"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙋‍♂️",
    "name": "man-raising-hand",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙋‍♀️",
    "name": "woman-raising-hand",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧏",
    "name": "deaf_person",
    "altNames": [],
    "keywords": [
      "accessibility",
      "ear",
      "hear"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧏‍♂️",
    "name": "deaf_man",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧏‍♀️",
    "name": "deaf_woman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙇",
    "name": "bow",
    "altNames": [],
    "keywords": [
      "apology",
      "gesture",
      "person bowing",
      "sorry"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙇‍♂️",
    "name": "man-bowing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🙇‍♀️",
    "name": "woman-bowing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤦",
    "name": "face_palm",
    "altNames": [],
    "keywords": [
      "disbelief",
      "exasperation",
      "person facepalming"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤦‍♂️",
    "name": "man-facepalming",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤦‍♀️",
    "name": "woman-facepalming",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤷",
    "name": "shrug",
    "altNames": [],
    "keywords": [
      "doubt",
      "ignorance",
      "indifference",
      "person shrugging"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤷‍♂️",
    "name": "man-shrugging",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤷‍♀️",
    "name": "woman-shrugging",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍⚕️",
    "name": "male-doctor",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍⚕️",
    "name": "female-doctor",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🎓",
    "name": "male-student",
    "altNames": [],
    "keywords": [
      "graduate",
      "man"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🎓",
    "name": "female-student",
    "altNames": [],
    "keywords": [
      "graduate",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🏫",
    "name": "male-teacher",
    "altNames": [],
    "keywords": [
      "instructor",
      "lecturer",
      "man",
      "professor"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🏫",
    "name": "female-teacher",
    "altNames": [],
    "keywords": [
      "instructor",
      "lecturer",
      "professor",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍⚖️",
    "name": "male-judge",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍⚖️",
    "name": "female-judge",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🌾",
    "name": "male-farmer",
    "altNames": [],
    "keywords": [
      "gardener",
      "man",
      "rancher"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🌾",
    "name": "female-farmer",
    "altNames": [],
    "keywords": [
      "gardener",
      "rancher",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🍳",
    "name": "male-cook",
    "altNames": [],
    "keywords": [
      "chef",
      "man"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🍳",
    "name": "female-cook",
    "altNames": [],
    "keywords": [
      "chef",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🔧",
    "name": "male-mechanic",
    "altNames": [],
    "keywords": [
      "electrician",
      "man",
      "plumber",
      "tradesperson"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🔧",
    "name": "female-mechanic",
    "altNames": [],
    "keywords": [
      "electrician",
      "plumber",
      "tradesperson",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🏭",
    "name": "male-factory-worker",
    "altNames": [],
    "keywords": [
      "assembly",
      "industrial",
      "man"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🏭",
    "name": "female-factory-worker",
    "altNames": [],
    "keywords": [
      "assembly",
      "industrial",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍💼",
    "name": "male-office-worker",
    "altNames": [],
    "keywords": [
      "architect",
      "business",
      "man",
      "man office worker",
      "manager",
      "white-collar"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍💼",
    "name": "female-office-worker",
    "altNames": [],
    "keywords": [
      "architect",
      "business",
      "manager",
      "white-collar",
      "woman",
      "woman office worker"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🔬",
    "name": "male-scientist",
    "altNames": [],
    "keywords": [
      "biologist",
      "chemist",
      "engineer",
      "man",
      "physicist"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🔬",
    "name": "female-scientist",
    "altNames": [],
    "keywords": [
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍💻",
    "name": "male-technologist",
    "altNames": [],
    "keywords": [
      "coder",
      "developer",
      "inventor",
      "man",
      "software"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍💻",
    "name": "female-technologist",
    "altNames": [],
    "keywords": [
      "coder",
      "developer",
      "inventor",
      "software",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🎤",
    "name": "male-singer",
    "altNames": [],
    "keywords": [
      "actor",
      "entertainer",
      "man",
      "rock",
      "star"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🎤",
    "name": "female-singer",
    "altNames": [],
    "keywords": [
      "actor",
      "entertainer",
      "rock",
      "star",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🎨",
    "name": "male-artist",
    "altNames": [],
    "keywords": [
      "man",
      "palette"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🎨",
    "name": "female-artist",
    "altNames": [],
    "keywords": [
      "palette",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍✈️",
    "name": "male-pilot",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍✈️",
    "name": "female-pilot",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🚀",
    "name": "male-astronaut",
    "altNames": [],
    "keywords": [
      "man",
      "rocket"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🚀",
    "name": "female-astronaut",
    "altNames": [],
    "keywords": [
      "rocket",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🚒",
    "name": "male-firefighter",
    "altNames": [],
    "keywords": [
      "firetruck",
      "man"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🚒",
    "name": "female-firefighter",
    "altNames": [],
    "keywords": [
      "firetruck",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👮",
    "name": "cop",
    "altNames": [],
    "keywords": [
      "officer",
      "police"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👮‍♂️",
    "name": "male-police-officer",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👮‍♀️",
    "name": "female-police-officer",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🕵️",
    "name": "sleuth_or_spy",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🕵️‍♂️",
    "name": "male-detective",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🕵️‍♀️",
    "name": "female-detective",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💂",
    "name": "guardsman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💂‍♂️",
    "name": "male-guard",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💂‍♀️",
    "name": "female-guard",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👷",
    "name": "construction_worker",
    "altNames": [],
    "keywords": [
      "hat"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👷‍♂️",
    "name": "male-construction-worker",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👷‍♀️",
    "name": "female-construction-worker",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤴",
    "name": "prince",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👸",
    "name": "princess",
    "altNames": [],
    "keywords": [
      "fairy tale",
      "fantasy"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👳",
    "name": "man_with_turban",
    "altNames": [],
    "keywords": [
      "person wearing turban"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👳‍♂️",
    "name": "man-wearing-turban",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👳‍♀️",
    "name": "woman-wearing-turban",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👲",
    "name": "man_with_gua_pi_mao",
    "altNames": [],
    "keywords": [
      "cap",
      "hat",
      "person",
      "person with skullcap",
      "skullcap"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧕",
    "name": "person_with_headscarf",
    "altNames": [],
    "keywords": [
      "hijab",
      "mantilla",
      "tichel",
      "woman with headscarf"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤵",
    "name": "person_in_tuxedo",
    "altNames": [],
    "keywords": [
      "groom"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👰",
    "name": "bride_with_veil",
    "altNames": [],
    "keywords": [
      "person",
      "person with veil",
      "wedding"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤰",
    "name": "pregnant_woman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤱",
    "name": "breast-feeding",
    "altNames": [],
    "keywords": [
      "baby",
      "nursing"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👼",
    "name": "angel",
    "altNames": [],
    "keywords": [
      "baby",
      "face",
      "fairy tale",
      "fantasy"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🎅",
    "name": "santa",
    "altNames": [],
    "keywords": [
      "celebration",
      "christmas",
      "claus",
      "father"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤶",
    "name": "mrs_claus",
    "altNames": [
      "mother_christmas"
    ],
    "keywords": [
      "celebration",
      "mrs."
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦸",
    "name": "superhero",
    "altNames": [],
    "keywords": [
      "good",
      "heroine",
      "superpower"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦸‍♂️",
    "name": "male_superhero",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦸‍♀️",
    "name": "female_superhero",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦹",
    "name": "supervillain",
    "altNames": [],
    "keywords": [
      "criminal",
      "evil",
      "superpower"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦹‍♂️",
    "name": "male_supervillain",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🦹‍♀️",
    "name": "female_supervillain",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧙",
    "name": "mage",
    "altNames": [],
    "keywords": [
      "sorcerer",
      "sorceress",
      "witch",
      "wizard"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧙‍♂️",
    "name": "male_mage",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧙‍♀️",
    "name": "female_mage",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧚",
    "name": "fairy",
    "altNames": [],
    "keywords": [
      "oberon",
      "puck",
      "titania"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧚‍♂️",
    "name": "male_fairy",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧚‍♀️",
    "name": "female_fairy",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧛",
    "name": "vampire",
    "altNames": [],
    "keywords": [
      "dracula",
      "undead"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧛‍♂️",
    "name": "male_vampire",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧛‍♀️",
    "name": "female_vampire",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧜",
    "name": "merperson",
    "altNames": [],
    "keywords": [
      "mermaid",
      "merman",
      "merwoman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧜‍♂️",
    "name": "merman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧜‍♀️",
    "name": "mermaid",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧝",
    "name": "elf",
    "altNames": [],
    "keywords": [
      "magical"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧝‍♂️",
    "name": "male_elf",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧝‍♀️",
    "name": "female_elf",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧞",
    "name": "genie",
    "altNames": [],
    "keywords": [
      "djinn"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧞‍♂️",
    "name": "male_genie",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧞‍♀️",
    "name": "female_genie",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧟",
    "name": "zombie",
    "altNames": [],
    "keywords": [
      "undead",
      "walking dead"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧟‍♂️",
    "name": "male_zombie",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧟‍♀️",
    "name": "female_zombie",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💆",
    "name": "massage",
    "altNames": [],
    "keywords": [
      "face",
      "person getting massage",
      "salon"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💆‍♂️",
    "name": "man-getting-massage",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💆‍♀️",
    "name": "woman-getting-massage",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💇",
    "name": "haircut",
    "altNames": [],
    "keywords": [
      "barber",
      "beauty",
      "parlor",
      "person getting haircut"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💇‍♂️",
    "name": "man-getting-haircut",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💇‍♀️",
    "name": "woman-getting-haircut",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚶",
    "name": "walking",
    "altNames": [],
    "keywords": [
      "hike",
      "person walking"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚶‍♂️",
    "name": "man-walking",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚶‍♀️",
    "name": "woman-walking",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧍",
    "name": "standing_person",
    "altNames": [],
    "keywords": [
      "person standing"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧍‍♂️",
    "name": "man_standing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧍‍♀️",
    "name": "woman_standing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧎",
    "name": "kneeling_person",
    "altNames": [],
    "keywords": [
      "person kneeling"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧎‍♂️",
    "name": "man_kneeling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧎‍♀️",
    "name": "woman_kneeling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦯",
    "name": "man_with_probing_cane",
    "altNames": [],
    "keywords": [
      "accessibility",
      "blind",
      "man with white cane"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦯",
    "name": "woman_with_probing_cane",
    "altNames": [],
    "keywords": [
      "accessibility",
      "blind",
      "woman with white cane"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦼",
    "name": "man_in_motorized_wheelchair",
    "altNames": [],
    "keywords": [
      "accessibility"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦼",
    "name": "woman_in_motorized_wheelchair",
    "altNames": [],
    "keywords": [
      "accessibility"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👨‍🦽",
    "name": "man_in_manual_wheelchair",
    "altNames": [],
    "keywords": [
      "accessibility"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍🦽",
    "name": "woman_in_manual_wheelchair",
    "altNames": [],
    "keywords": [
      "accessibility"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏃",
    "name": "runner",
    "altNames": [
      "running"
    ],
    "keywords": [
      "marathon",
      "person running"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏃‍♂️",
    "name": "man-running",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏃‍♀️",
    "name": "woman-running",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💃",
    "name": "dancer",
    "altNames": [],
    "keywords": [
      "dancing",
      "woman"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🕺",
    "name": "man_dancing",
    "altNames": [],
    "keywords": [
      "dance"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🕴️",
    "name": "man_in_business_suit_levitating",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👯",
    "name": "dancers",
    "altNames": [],
    "keywords": [
      "bunny ear",
      "partying",
      "people with bunny ears"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👯‍♂️",
    "name": "men-with-bunny-ears-partying",
    "altNames": [
      "man-with-bunny-ears-partying"
    ],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👯‍♀️",
    "name": "women-with-bunny-ears-partying",
    "altNames": [
      "woman-with-bunny-ears-partying"
    ],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🧖",
    "name": "person_in_steamy_room",
    "altNames": [],
    "keywords": [
      "sauna",
      "steam room"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧖‍♂️",
    "name": "man_in_steamy_room",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧖‍♀️",
    "name": "woman_in_steamy_room",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧗",
    "name": "person_climbing",
    "altNames": [],
    "keywords": [
      "climber"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧗‍♂️",
    "name": "man_climbing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧗‍♀️",
    "name": "woman_climbing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤺",
    "name": "fencer",
    "altNames": [],
    "keywords": [
      "fencing",
      "person fencing",
      "sword"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🏇",
    "name": "horse_racing",
    "altNames": [],
    "keywords": [
      "jockey",
      "racehorse"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "⛷️",
    "name": "skier",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🏂",
    "name": "snowboarder",
    "altNames": [],
    "keywords": [
      "ski"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏌️",
    "name": "golfer",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏌️‍♂️",
    "name": "man-golfing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏌️‍♀️",
    "name": "woman-golfing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏄",
    "name": "surfer",
    "altNames": [],
    "keywords": [
      "person surfing",
      "surfing"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏄‍♂️",
    "name": "man-surfing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏄‍♀️",
    "name": "woman-surfing",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚣",
    "name": "rowboat",
    "altNames": [],
    "keywords": [
      "person rowing boat"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚣‍♂️",
    "name": "man-rowing-boat",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚣‍♀️",
    "name": "woman-rowing-boat",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏊",
    "name": "swimmer",
    "altNames": [],
    "keywords": [
      "person swimming"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏊‍♂️",
    "name": "man-swimming",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏊‍♀️",
    "name": "woman-swimming",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "⛹️",
    "name": "person_with_ball",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "⛹️‍♂️",
    "name": "man-bouncing-ball",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "⛹️‍♀️",
    "name": "woman-bouncing-ball",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏋️",
    "name": "weight_lifter",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏋️‍♂️",
    "name": "man-lifting-weights",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🏋️‍♀️",
    "name": "woman-lifting-weights",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚴",
    "name": "bicyclist",
    "altNames": [],
    "keywords": [
      "bicycle",
      "biking",
      "person biking"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚴‍♂️",
    "name": "man-biking",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚴‍♀️",
    "name": "woman-biking",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚵",
    "name": "mountain_bicyclist",
    "altNames": [],
    "keywords": [
      "bicycle",
      "bike",
      "person mountain biking"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚵‍♂️",
    "name": "man-mountain-biking",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🚵‍♀️",
    "name": "woman-mountain-biking",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤸",
    "name": "person_doing_cartwheel",
    "altNames": [],
    "keywords": [
      "gymnastics",
      "person cartwheeling"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤸‍♂️",
    "name": "man-cartwheeling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤸‍♀️",
    "name": "woman-cartwheeling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤼",
    "name": "wrestlers",
    "altNames": [],
    "keywords": [
      "people wrestling"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤼‍♂️",
    "name": "man-wrestling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤼‍♀️",
    "name": "woman-wrestling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🤽",
    "name": "water_polo",
    "altNames": [],
    "keywords": [
      "person playing water polo"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤽‍♂️",
    "name": "man-playing-water-polo",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤽‍♀️",
    "name": "woman-playing-water-polo",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤾",
    "name": "handball",
    "altNames": [],
    "keywords": [
      "person playing handball"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤾‍♂️",
    "name": "man-playing-handball",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤾‍♀️",
    "name": "woman-playing-handball",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤹",
    "name": "juggling",
    "altNames": [],
    "keywords": [
      "balance",
      "juggle",
      "multitask",
      "person juggling",
      "skill"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤹‍♂️",
    "name": "man-juggling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🤹‍♀️",
    "name": "woman-juggling",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧘",
    "name": "person_in_lotus_position",
    "altNames": [],
    "keywords": [
      "meditation",
      "yoga"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧘‍♂️",
    "name": "man_in_lotus_position",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧘‍♀️",
    "name": "woman_in_lotus_position",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🛀",
    "name": "bath",
    "altNames": [],
    "keywords": [
      "bathtub",
      "person taking bath"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🛌",
    "name": "sleeping_accommodation",
    "altNames": [],
    "keywords": [
      "good night",
      "hotel",
      "person in bed"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "🧑‍🤝‍🧑",
    "name": "people_holding_hands",
    "altNames": [],
    "keywords": [
      "couple",
      "person"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👭",
    "name": "two_women_holding_hands",
    "altNames": [
      "women_holding_hands"
    ],
    "keywords": [
      "couple"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👫",
    "name": "man_and_woman_holding_hands",
    "altNames": [
      "woman_and_man_holding_hands",
      "couple"
    ],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👬",
    "name": "two_men_holding_hands",
    "altNames": [
      "men_holding_hands"
    ],
    "keywords": [
      "couple",
      "gemini",
      "man",
      "twins",
      "zodiac"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "💏",
    "name": "couplekiss",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍❤️‍💋‍👨",
    "name": "woman-kiss-man",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍❤️‍💋‍👨",
    "name": "man-kiss-man",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍❤️‍💋‍👩",
    "name": "woman-kiss-woman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "💑",
    "name": "couple_with_heart",
    "altNames": [],
    "keywords": [
      "love"
    ],
    "category": "people",
    "fitzpatrickScale": true
  },
  {
    "char": "👩‍❤️‍👨",
    "name": "woman-heart-man",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍❤️‍👨",
    "name": "man-heart-man",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍❤️‍👩",
    "name": "woman-heart-woman",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👩‍👦",
    "name": "man-woman-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, woman, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👩‍👧",
    "name": "man-woman-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, woman, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👩‍👧‍👦",
    "name": "man-woman-girl-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, woman, girl, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👩‍👦‍👦",
    "name": "man-woman-boy-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, woman, boy, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👩‍👧‍👧",
    "name": "man-woman-girl-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, woman, girl, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👨‍👦",
    "name": "man-man-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, man, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👨‍👧",
    "name": "man-man-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, man, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👨‍👧‍👦",
    "name": "man-man-girl-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, man, girl, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👨‍👦‍👦",
    "name": "man-man-boy-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, man, boy, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👨‍👧‍👧",
    "name": "man-man-girl-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, man, girl, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👩‍👦",
    "name": "woman-woman-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, woman, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👩‍👧",
    "name": "woman-woman-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, woman, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👩‍👧‍👦",
    "name": "woman-woman-girl-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, woman, girl, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👩‍👦‍👦",
    "name": "woman-woman-boy-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, woman, boy, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👩‍👧‍👧",
    "name": "woman-woman-girl-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, woman, girl, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👦",
    "name": "man-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👦‍👦",
    "name": "man-boy-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, boy, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👧",
    "name": "man-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👧‍👦",
    "name": "man-girl-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, girl, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👨‍👧‍👧",
    "name": "man-girl-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: man, girl, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👦",
    "name": "woman-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👦‍👦",
    "name": "woman-boy-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, boy, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👧",
    "name": "woman-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👧‍👦",
    "name": "woman-girl-boy",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, girl, boy"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👩‍👧‍👧",
    "name": "woman-girl-girl",
    "altNames": [],
    "keywords": [
      "family",
      "family: woman, girl, girl"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🗣️",
    "name": "speaking_head_in_silhouette",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👤",
    "name": "bust_in_silhouette",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👥",
    "name": "busts_in_silhouette",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👪",
    "name": "family",
    "altNames": [],
    "keywords": [],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "👣",
    "name": "footprints",
    "altNames": [],
    "keywords": [
      "clothing"
    ],
    "category": "people",
    "fitzpatrickScale": false
  },
  {
    "char": "🐵",
    "name": "monkey_face",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐒",
    "name": "monkey",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦍",
    "name": "gorilla",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦧",
    "name": "orangutan",
    "altNames": [],
    "keywords": [
      "ape"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐶",
    "name": "dog",
    "altNames": [],
    "keywords": [
      "face",
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐕",
    "name": "dog2",
    "altNames": [],
    "keywords": [
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦮",
    "name": "guide_dog",
    "altNames": [],
    "keywords": [
      "accessibility",
      "blind"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐕‍🦺",
    "name": "service_dog",
    "altNames": [],
    "keywords": [
      "accessibility",
      "assistance"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐩",
    "name": "poodle",
    "altNames": [],
    "keywords": [
      "dog"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐺",
    "name": "wolf",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦊",
    "name": "fox_face",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦝",
    "name": "raccoon",
    "altNames": [],
    "keywords": [
      "curious",
      "sly"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐱",
    "name": "cat",
    "altNames": [],
    "keywords": [
      "face",
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐈",
    "name": "cat2",
    "altNames": [],
    "keywords": [
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦁",
    "name": "lion_face",
    "altNames": [],
    "keywords": [
      "leo",
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐯",
    "name": "tiger",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐅",
    "name": "tiger2",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐆",
    "name": "leopard",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐴",
    "name": "horse",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐎",
    "name": "racehorse",
    "altNames": [],
    "keywords": [
      "equestrian",
      "racing"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦄",
    "name": "unicorn_face",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦓",
    "name": "zebra_face",
    "altNames": [],
    "keywords": [
      "stripe"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦌",
    "name": "deer",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐮",
    "name": "cow",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐂",
    "name": "ox",
    "altNames": [],
    "keywords": [
      "bull",
      "taurus",
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐃",
    "name": "water_buffalo",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐄",
    "name": "cow2",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐷",
    "name": "pig",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐖",
    "name": "pig2",
    "altNames": [],
    "keywords": [
      "sow"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐗",
    "name": "boar",
    "altNames": [],
    "keywords": [
      "pig"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐽",
    "name": "pig_nose",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐏",
    "name": "ram",
    "altNames": [],
    "keywords": [
      "aries",
      "male",
      "sheep",
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐑",
    "name": "sheep",
    "altNames": [],
    "keywords": [
      "ewe",
      "female"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐐",
    "name": "goat",
    "altNames": [],
    "keywords": [
      "capricorn",
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐪",
    "name": "dromedary_camel",
    "altNames": [],
    "keywords": [
      "hump"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐫",
    "name": "camel",
    "altNames": [],
    "keywords": [
      "bactrian",
      "hump",
      "two-hump camel"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦙",
    "name": "llama",
    "altNames": [],
    "keywords": [
      "alpaca",
      "guanaco",
      "vicuña",
      "wool"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦒",
    "name": "giraffe_face",
    "altNames": [],
    "keywords": [
      "spots"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐘",
    "name": "elephant",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦏",
    "name": "rhinoceros",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦛",
    "name": "hippopotamus",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐭",
    "name": "mouse",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐁",
    "name": "mouse2",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐀",
    "name": "rat",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐹",
    "name": "hamster",
    "altNames": [],
    "keywords": [
      "face",
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐰",
    "name": "rabbit",
    "altNames": [],
    "keywords": [
      "bunny",
      "face",
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐇",
    "name": "rabbit2",
    "altNames": [],
    "keywords": [
      "bunny",
      "pet"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐿️",
    "name": "chipmunk",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦔",
    "name": "hedgehog",
    "altNames": [],
    "keywords": [
      "spiny"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦇",
    "name": "bat",
    "altNames": [],
    "keywords": [
      "vampire"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐻",
    "name": "bear",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐨",
    "name": "koala",
    "altNames": [],
    "keywords": [
      "face",
      "marsupial"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐼",
    "name": "panda_face",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦥",
    "name": "sloth",
    "altNames": [],
    "keywords": [
      "lazy",
      "slow"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦦",
    "name": "otter",
    "altNames": [],
    "keywords": [
      "fishing",
      "playful"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦨",
    "name": "skunk",
    "altNames": [],
    "keywords": [
      "stink"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦘",
    "name": "kangaroo",
    "altNames": [],
    "keywords": [
      "joey",
      "jump",
      "marsupial"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦡",
    "name": "badger",
    "altNames": [],
    "keywords": [
      "honey badger",
      "pester"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐾",
    "name": "feet",
    "altNames": [
      "paw_prints"
    ],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦃",
    "name": "turkey",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐔",
    "name": "chicken",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐓",
    "name": "rooster",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐣",
    "name": "hatching_chick",
    "altNames": [],
    "keywords": [
      "baby",
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐤",
    "name": "baby_chick",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐥",
    "name": "hatched_chick",
    "altNames": [],
    "keywords": [
      "baby",
      "bird",
      "front-facing baby chick"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐦",
    "name": "bird",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐧",
    "name": "penguin",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🕊️",
    "name": "dove_of_peace",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦅",
    "name": "eagle",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦆",
    "name": "duck",
    "altNames": [],
    "keywords": [
      "bird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦢",
    "name": "swan",
    "altNames": [],
    "keywords": [
      "bird",
      "cygnet",
      "ugly duckling"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦉",
    "name": "owl",
    "altNames": [],
    "keywords": [
      "bird",
      "wise"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦩",
    "name": "flamingo",
    "altNames": [],
    "keywords": [
      "flamboyant",
      "tropical"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦚",
    "name": "peacock",
    "altNames": [],
    "keywords": [
      "bird",
      "ostentatious",
      "peahen",
      "proud"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦜",
    "name": "parrot",
    "altNames": [],
    "keywords": [
      "bird",
      "pirate",
      "talk"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐸",
    "name": "frog",
    "altNames": [],
    "keywords": [
      "face"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐊",
    "name": "crocodile",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐢",
    "name": "turtle",
    "altNames": [],
    "keywords": [
      "terrapin",
      "tortoise"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦎",
    "name": "lizard",
    "altNames": [],
    "keywords": [
      "reptile"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐍",
    "name": "snake",
    "altNames": [],
    "keywords": [
      "bearer",
      "ophiuchus",
      "serpent",
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐲",
    "name": "dragon_face",
    "altNames": [],
    "keywords": [
      "fairy tale"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐉",
    "name": "dragon",
    "altNames": [],
    "keywords": [
      "fairy tale"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦕",
    "name": "sauropod",
    "altNames": [],
    "keywords": [
      "brachiosaurus",
      "brontosaurus",
      "diplodocus"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦖",
    "name": "t-rex",
    "altNames": [],
    "keywords": [
      "tyrannosaurus rex"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐳",
    "name": "whale",
    "altNames": [],
    "keywords": [
      "face",
      "spouting"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐋",
    "name": "whale2",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐬",
    "name": "dolphin",
    "altNames": [
      "flipper"
    ],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐟",
    "name": "fish",
    "altNames": [],
    "keywords": [
      "pisces",
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐠",
    "name": "tropical_fish",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐡",
    "name": "blowfish",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦈",
    "name": "shark",
    "altNames": [],
    "keywords": [
      "fish"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐙",
    "name": "octopus",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐚",
    "name": "shell",
    "altNames": [],
    "keywords": [
      "spiral"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐌",
    "name": "snail",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦋",
    "name": "butterfly",
    "altNames": [],
    "keywords": [
      "insect",
      "pretty"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐛",
    "name": "bug",
    "altNames": [],
    "keywords": [
      "insect"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐜",
    "name": "ant",
    "altNames": [],
    "keywords": [
      "insect"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐝",
    "name": "bee",
    "altNames": [
      "honeybee"
    ],
    "keywords": [
      "insect"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🐞",
    "name": "ladybug",
    "altNames": [
      "lady_beetle"
    ],
    "keywords": [
      "insect",
      "ladybird"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦗",
    "name": "cricket",
    "altNames": [],
    "keywords": [
      "grasshopper"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🕷️",
    "name": "spider",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🕸️",
    "name": "spider_web",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦂",
    "name": "scorpion",
    "altNames": [],
    "keywords": [
      "zodiac"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦟",
    "name": "mosquito",
    "altNames": [],
    "keywords": [
      "disease",
      "fever",
      "malaria",
      "pest",
      "virus"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🦠",
    "name": "microbe",
    "altNames": [],
    "keywords": [
      "amoeba",
      "bacteria",
      "virus"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "💐",
    "name": "bouquet",
    "altNames": [],
    "keywords": [
      "flower"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌸",
    "name": "cherry_blossom",
    "altNames": [],
    "keywords": [
      "flower"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "💮",
    "name": "white_flower",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🏵️",
    "name": "rosette",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌹",
    "name": "rose",
    "altNames": [],
    "keywords": [
      "flower"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🥀",
    "name": "wilted_flower",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌺",
    "name": "hibiscus",
    "altNames": [],
    "keywords": [
      "flower"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌻",
    "name": "sunflower",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌼",
    "name": "blossom",
    "altNames": [],
    "keywords": [
      "flower"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌷",
    "name": "tulip",
    "altNames": [],
    "keywords": [
      "flower"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌱",
    "name": "seedling",
    "altNames": [],
    "keywords": [
      "young"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌲",
    "name": "evergreen_tree",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌳",
    "name": "deciduous_tree",
    "altNames": [],
    "keywords": [
      "shedding"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌴",
    "name": "palm_tree",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌵",
    "name": "cactus",
    "altNames": [],
    "keywords": [
      "plant"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌾",
    "name": "ear_of_rice",
    "altNames": [],
    "keywords": [
      "grain",
      "sheaf of rice"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🌿",
    "name": "herb",
    "altNames": [],
    "keywords": [
      "leaf"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "☘️",
    "name": "shamrock",
    "altNames": [],
    "keywords": [],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🍀",
    "name": "four_leaf_clover",
    "altNames": [],
    "keywords": [
      "4"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🍁",
    "name": "maple_leaf",
    "altNames": [],
    "keywords": [
      "falling"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🍂",
    "name": "fallen_leaf",
    "altNames": [],
    "keywords": [
      "falling"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🍃",
    "name": "leaves",
    "altNames": [],
    "keywords": [
      "blow",
      "flutter",
      "leaf",
      "leaf fluttering in wind",
      "wind"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🍄",
    "name": "mushroom",
    "altNames": [],
    "keywords": [
      "toadstool"
    ],
    "category": "animals_and_nature",
    "fitzpatrickScale": false
  },
  {
    "char": "🍇",
    "name": "grapes",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍈",
    "name": "melon",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍉",
    "name": "watermelon",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍊",
    "name": "tangerine",
    "altNames": [],
    "keywords": [
      "fruit",
      "orange"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍋",
    "name": "lemon",
    "altNames": [],
    "keywords": [
      "citrus",
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍌",
    "name": "banana",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍍",
    "name": "pineapple",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥭",
    "name": "mango",
    "altNames": [],
    "keywords": [
      "fruit",
      "tropical"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍎",
    "name": "apple",
    "altNames": [],
    "keywords": [
      "fruit",
      "red"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍏",
    "name": "green_apple",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍐",
    "name": "pear",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍑",
    "name": "peach",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍒",
    "name": "cherries",
    "altNames": [],
    "keywords": [
      "berries",
      "cherry",
      "fruit",
      "red"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍓",
    "name": "strawberry",
    "altNames": [],
    "keywords": [
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥝",
    "name": "kiwifruit",
    "altNames": [],
    "keywords": [
      "food"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍅",
    "name": "tomato",
    "altNames": [],
    "keywords": [
      "fruit",
      "vegetable"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥥",
    "name": "coconut",
    "altNames": [],
    "keywords": [
      "palm",
      "piña colada"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥑",
    "name": "avocado",
    "altNames": [],
    "keywords": [
      "food",
      "fruit"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍆",
    "name": "eggplant",
    "altNames": [],
    "keywords": [
      "aubergine",
      "vegetable"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥔",
    "name": "potato",
    "altNames": [],
    "keywords": [
      "food",
      "vegetable"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥕",
    "name": "carrot",
    "altNames": [],
    "keywords": [
      "food",
      "vegetable"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌽",
    "name": "corn",
    "altNames": [],
    "keywords": [
      "ear",
      "ear of corn",
      "maize",
      "maze"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌶️",
    "name": "hot_pepper",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥒",
    "name": "cucumber",
    "altNames": [],
    "keywords": [
      "food",
      "pickle",
      "vegetable"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥬",
    "name": "leafy_green",
    "altNames": [],
    "keywords": [
      "bok choy",
      "cabbage",
      "kale",
      "lettuce"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥦",
    "name": "broccoli",
    "altNames": [],
    "keywords": [
      "wild cabbage"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧄",
    "name": "garlic",
    "altNames": [],
    "keywords": [
      "flavoring"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧅",
    "name": "onion",
    "altNames": [],
    "keywords": [
      "flavoring"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥜",
    "name": "peanuts",
    "altNames": [],
    "keywords": [
      "food",
      "vegetable"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌰",
    "name": "chestnut",
    "altNames": [],
    "keywords": [
      "plant"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍞",
    "name": "bread",
    "altNames": [],
    "keywords": [
      "loaf"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥐",
    "name": "croissant",
    "altNames": [],
    "keywords": [
      "bread",
      "breakfast",
      "food",
      "french",
      "roll"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥖",
    "name": "baguette_bread",
    "altNames": [],
    "keywords": [
      "food",
      "french"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥨",
    "name": "pretzel",
    "altNames": [],
    "keywords": [
      "twisted"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥯",
    "name": "bagel",
    "altNames": [],
    "keywords": [
      "bakery",
      "breakfast",
      "schmear"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥞",
    "name": "pancakes",
    "altNames": [],
    "keywords": [
      "breakfast",
      "crêpe",
      "food",
      "hotcake"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧇",
    "name": "waffle",
    "altNames": [],
    "keywords": [
      "breakfast",
      "indecisive",
      "iron"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧀",
    "name": "cheese_wedge",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍖",
    "name": "meat_on_bone",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍗",
    "name": "poultry_leg",
    "altNames": [],
    "keywords": [
      "bone",
      "chicken",
      "drumstick"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥩",
    "name": "cut_of_meat",
    "altNames": [],
    "keywords": [
      "chop",
      "lambchop",
      "porkchop",
      "steak"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥓",
    "name": "bacon",
    "altNames": [],
    "keywords": [
      "breakfast",
      "food",
      "meat"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍔",
    "name": "hamburger",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍟",
    "name": "fries",
    "altNames": [],
    "keywords": [
      "french"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍕",
    "name": "pizza",
    "altNames": [],
    "keywords": [
      "cheese",
      "slice"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌭",
    "name": "hotdog",
    "altNames": [],
    "keywords": [
      "frankfurter",
      "sausage"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥪",
    "name": "sandwich",
    "altNames": [],
    "keywords": [
      "bread"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌮",
    "name": "taco",
    "altNames": [],
    "keywords": [
      "mexican"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌯",
    "name": "burrito",
    "altNames": [],
    "keywords": [
      "mexican",
      "wrap"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥙",
    "name": "stuffed_flatbread",
    "altNames": [],
    "keywords": [
      "falafel",
      "food",
      "gyro",
      "kebab"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧆",
    "name": "falafel",
    "altNames": [],
    "keywords": [
      "chickpea",
      "meatball"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥚",
    "name": "egg",
    "altNames": [],
    "keywords": [
      "breakfast",
      "food"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍳",
    "name": "fried_egg",
    "altNames": [
      "cooking"
    ],
    "keywords": [
      "breakfast",
      "frying",
      "pan"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥘",
    "name": "shallow_pan_of_food",
    "altNames": [],
    "keywords": [
      "casserole",
      "paella"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍲",
    "name": "stew",
    "altNames": [],
    "keywords": [
      "pot",
      "pot of food"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥣",
    "name": "bowl_with_spoon",
    "altNames": [],
    "keywords": [
      "breakfast",
      "cereal",
      "congee"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥗",
    "name": "green_salad",
    "altNames": [],
    "keywords": [
      "food"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍿",
    "name": "popcorn",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧈",
    "name": "butter",
    "altNames": [],
    "keywords": [
      "dairy"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧂",
    "name": "salt",
    "altNames": [],
    "keywords": [
      "condiment",
      "shaker"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥫",
    "name": "canned_food",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍱",
    "name": "bento",
    "altNames": [],
    "keywords": [
      "box"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍘",
    "name": "rice_cracker",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍙",
    "name": "rice_ball",
    "altNames": [],
    "keywords": [
      "japanese"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍚",
    "name": "rice",
    "altNames": [],
    "keywords": [
      "cooked"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍛",
    "name": "curry",
    "altNames": [],
    "keywords": [
      "rice"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍜",
    "name": "ramen",
    "altNames": [],
    "keywords": [
      "bowl",
      "noodle",
      "steaming"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍝",
    "name": "spaghetti",
    "altNames": [],
    "keywords": [
      "pasta"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍠",
    "name": "sweet_potato",
    "altNames": [],
    "keywords": [
      "roasted"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍢",
    "name": "oden",
    "altNames": [],
    "keywords": [
      "kebab",
      "seafood",
      "skewer",
      "stick"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍣",
    "name": "sushi",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍤",
    "name": "fried_shrimp",
    "altNames": [],
    "keywords": [
      "prawn",
      "tempura"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍥",
    "name": "fish_cake",
    "altNames": [],
    "keywords": [
      "fish cake with swirl",
      "pastry",
      "swirl"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥮",
    "name": "moon_cake",
    "altNames": [],
    "keywords": [
      "autumn",
      "festival",
      "yuèbǐng"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍡",
    "name": "dango",
    "altNames": [],
    "keywords": [
      "dessert",
      "japanese",
      "skewer",
      "stick",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥟",
    "name": "dumpling",
    "altNames": [],
    "keywords": [
      "empanada",
      "gyōza",
      "jiaozi",
      "pierogi",
      "potsticker"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥠",
    "name": "fortune_cookie",
    "altNames": [],
    "keywords": [
      "prophecy"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥡",
    "name": "takeout_box",
    "altNames": [],
    "keywords": [
      "oyster pail"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🦀",
    "name": "crab",
    "altNames": [],
    "keywords": [
      "cancer",
      "zodiac"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🦞",
    "name": "lobster",
    "altNames": [],
    "keywords": [
      "bisque",
      "claws",
      "seafood"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🦐",
    "name": "shrimp",
    "altNames": [],
    "keywords": [
      "food",
      "shellfish",
      "small"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🦑",
    "name": "squid",
    "altNames": [],
    "keywords": [
      "food",
      "molusc"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🦪",
    "name": "oyster",
    "altNames": [],
    "keywords": [
      "diving",
      "pearl"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍦",
    "name": "icecream",
    "altNames": [],
    "keywords": [
      "dessert",
      "soft",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍧",
    "name": "shaved_ice",
    "altNames": [],
    "keywords": [
      "dessert",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍨",
    "name": "ice_cream",
    "altNames": [],
    "keywords": [
      "dessert",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍩",
    "name": "doughnut",
    "altNames": [],
    "keywords": [
      "breakfast",
      "dessert",
      "donut",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍪",
    "name": "cookie",
    "altNames": [],
    "keywords": [
      "dessert",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🎂",
    "name": "birthday",
    "altNames": [],
    "keywords": [
      "cake",
      "celebration",
      "dessert",
      "pastry",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍰",
    "name": "cake",
    "altNames": [],
    "keywords": [
      "dessert",
      "pastry",
      "shortcake",
      "slice",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧁",
    "name": "cupcake",
    "altNames": [],
    "keywords": [
      "bakery",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥧",
    "name": "pie",
    "altNames": [],
    "keywords": [
      "filling",
      "pastry"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍫",
    "name": "chocolate_bar",
    "altNames": [],
    "keywords": [
      "dessert",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍬",
    "name": "candy",
    "altNames": [],
    "keywords": [
      "dessert",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍭",
    "name": "lollipop",
    "altNames": [],
    "keywords": [
      "candy",
      "dessert",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍮",
    "name": "custard",
    "altNames": [],
    "keywords": [
      "dessert",
      "pudding",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍯",
    "name": "honey_pot",
    "altNames": [],
    "keywords": [
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍼",
    "name": "baby_bottle",
    "altNames": [],
    "keywords": [
      "drink",
      "milk"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥛",
    "name": "glass_of_milk",
    "altNames": [],
    "keywords": [
      "drink"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "☕",
    "name": "coffee",
    "altNames": [],
    "keywords": [
      "beverage",
      "drink",
      "hot",
      "steaming",
      "tea"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍵",
    "name": "tea",
    "altNames": [],
    "keywords": [
      "beverage",
      "cup",
      "drink",
      "teacup",
      "teacup without handle"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍶",
    "name": "sake",
    "altNames": [],
    "keywords": [
      "bar",
      "beverage",
      "bottle",
      "cup",
      "drink"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍾",
    "name": "champagne",
    "altNames": [],
    "keywords": [
      "bar",
      "bottle",
      "bottle with popping cork",
      "cork",
      "drink",
      "popping"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍷",
    "name": "wine_glass",
    "altNames": [],
    "keywords": [
      "bar",
      "beverage",
      "drink"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍸",
    "name": "cocktail",
    "altNames": [],
    "keywords": [
      "bar",
      "drink",
      "glass"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍹",
    "name": "tropical_drink",
    "altNames": [],
    "keywords": [
      "bar"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍺",
    "name": "beer",
    "altNames": [],
    "keywords": [
      "bar",
      "drink",
      "mug"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍻",
    "name": "beers",
    "altNames": [],
    "keywords": [
      "bar",
      "clink",
      "clinking beer mugs",
      "drink",
      "mug"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥂",
    "name": "clinking_glasses",
    "altNames": [],
    "keywords": [
      "celebrate",
      "drink"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥃",
    "name": "tumbler_glass",
    "altNames": [],
    "keywords": [
      "liquor",
      "shot",
      "whisky"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥤",
    "name": "cup_with_straw",
    "altNames": [],
    "keywords": [
      "juice",
      "soda"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧃",
    "name": "beverage_box",
    "altNames": [],
    "keywords": [
      "juice",
      "straw",
      "sweet"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧉",
    "name": "mate_drink",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🧊",
    "name": "ice_cube",
    "altNames": [],
    "keywords": [
      "cold",
      "iceberg"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥢",
    "name": "chopsticks",
    "altNames": [],
    "keywords": [
      "hashi"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍽️",
    "name": "knife_fork_plate",
    "altNames": [],
    "keywords": [],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🍴",
    "name": "fork_and_knife",
    "altNames": [],
    "keywords": [
      "cooking",
      "cutlery"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🥄",
    "name": "spoon",
    "altNames": [],
    "keywords": [
      "tableware"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🔪",
    "name": "hocho",
    "altNames": [
      "knife"
    ],
    "keywords": [
      "cooking",
      "kitchen knife",
      "tool",
      "weapon"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🏺",
    "name": "amphora",
    "altNames": [],
    "keywords": [
      "aquarius",
      "cooking",
      "drink",
      "jug",
      "zodiac"
    ],
    "category": "food_and_drink",
    "fitzpatrickScale": false
  },
  {
    "char": "🌍",
    "name": "earth_africa",
    "altNames": [],
    "keywords": [
      "europe",
      "globe",
      "globe showing europe-africa",
      "world"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌎",
    "name": "earth_americas",
    "altNames": [],
    "keywords": [
      "globe",
      "globe showing americas",
      "world"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌏",
    "name": "earth_asia",
    "altNames": [],
    "keywords": [
      "australia",
      "globe",
      "globe showing asia-australia",
      "world"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌐",
    "name": "globe_with_meridians",
    "altNames": [],
    "keywords": [
      "earth",
      "world"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🗺️",
    "name": "world_map",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🗾",
    "name": "japan",
    "altNames": [],
    "keywords": [
      "map",
      "map of japan"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🧭",
    "name": "compass",
    "altNames": [],
    "keywords": [
      "magnetic",
      "navigation",
      "orienteering"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏔️",
    "name": "snow_capped_mountain",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛰️",
    "name": "mountain",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌋",
    "name": "volcano",
    "altNames": [],
    "keywords": [
      "eruption",
      "mountain"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🗻",
    "name": "mount_fuji",
    "altNames": [],
    "keywords": [
      "mountain"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏕️",
    "name": "camping",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏖️",
    "name": "beach_with_umbrella",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏜️",
    "name": "desert",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏝️",
    "name": "desert_island",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏞️",
    "name": "national_park",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏟️",
    "name": "stadium",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏛️",
    "name": "classical_building",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏗️",
    "name": "building_construction",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🧱",
    "name": "bricks",
    "altNames": [],
    "keywords": [
      "clay",
      "mortar",
      "wall"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏘️",
    "name": "house_buildings",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏚️",
    "name": "derelict_house_building",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏠",
    "name": "house",
    "altNames": [],
    "keywords": [
      "home"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏡",
    "name": "house_with_garden",
    "altNames": [],
    "keywords": [
      "home"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏢",
    "name": "office",
    "altNames": [],
    "keywords": [
      "building",
      "office building"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏣",
    "name": "post_office",
    "altNames": [],
    "keywords": [
      "japanese",
      "japanese post office"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏤",
    "name": "european_post_office",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏥",
    "name": "hospital",
    "altNames": [],
    "keywords": [
      "doctor",
      "medicine"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏦",
    "name": "bank",
    "altNames": [],
    "keywords": [
      "building"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏨",
    "name": "hotel",
    "altNames": [],
    "keywords": [
      "building"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏩",
    "name": "love_hotel",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏪",
    "name": "convenience_store",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏫",
    "name": "school",
    "altNames": [],
    "keywords": [
      "building"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏬",
    "name": "department_store",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏭",
    "name": "factory",
    "altNames": [],
    "keywords": [
      "building"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏯",
    "name": "japanese_castle",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏰",
    "name": "european_castle",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "💒",
    "name": "wedding",
    "altNames": [],
    "keywords": [
      "chapel",
      "romance"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🗼",
    "name": "tokyo_tower",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🗽",
    "name": "statue_of_liberty",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛪",
    "name": "church",
    "altNames": [],
    "keywords": [
      "christian",
      "cross",
      "religion"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕌",
    "name": "mosque",
    "altNames": [],
    "keywords": [
      "islam",
      "muslim",
      "religion"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛕",
    "name": "hindu_temple",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕍",
    "name": "synagogue",
    "altNames": [],
    "keywords": [
      "jew",
      "jewish",
      "religion",
      "temple"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛩️",
    "name": "shinto_shrine",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕋",
    "name": "kaaba",
    "altNames": [],
    "keywords": [
      "islam",
      "muslim",
      "religion"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛲",
    "name": "fountain",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛺",
    "name": "tent",
    "altNames": [],
    "keywords": [
      "camping"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌁",
    "name": "foggy",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌃",
    "name": "night_with_stars",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏙️",
    "name": "cityscape",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌄",
    "name": "sunrise_over_mountains",
    "altNames": [],
    "keywords": [
      "morning"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌅",
    "name": "sunrise",
    "altNames": [],
    "keywords": [
      "morning"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌆",
    "name": "city_sunset",
    "altNames": [],
    "keywords": [
      "cityscape at dusk",
      "dusk",
      "evening",
      "landscape"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌇",
    "name": "city_sunrise",
    "altNames": [],
    "keywords": [
      "dusk",
      "sunset"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌉",
    "name": "bridge_at_night",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "♨️",
    "name": "hotsprings",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🎠",
    "name": "carousel_horse",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🎡",
    "name": "ferris_wheel",
    "altNames": [],
    "keywords": [
      "amusement park",
      "theme park"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🎢",
    "name": "roller_coaster",
    "altNames": [],
    "keywords": [
      "amusement park",
      "theme park"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "💈",
    "name": "barber",
    "altNames": [],
    "keywords": [
      "haircut",
      "pole"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🎪",
    "name": "circus_tent",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚂",
    "name": "steam_locomotive",
    "altNames": [],
    "keywords": [
      "engine",
      "railway",
      "train"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚃",
    "name": "railway_car",
    "altNames": [],
    "keywords": [
      "electric",
      "train",
      "tram",
      "trolleybus"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚄",
    "name": "bullettrain_side",
    "altNames": [],
    "keywords": [
      "high-speed train",
      "railway",
      "shinkansen",
      "speed"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚅",
    "name": "bullettrain_front",
    "altNames": [],
    "keywords": [
      "railway",
      "shinkansen",
      "speed"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚆",
    "name": "train2",
    "altNames": [],
    "keywords": [
      "railway"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚇",
    "name": "metro",
    "altNames": [],
    "keywords": [
      "subway"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚈",
    "name": "light_rail",
    "altNames": [],
    "keywords": [
      "railway"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚉",
    "name": "station",
    "altNames": [],
    "keywords": [
      "railway",
      "train"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚊",
    "name": "tram",
    "altNames": [],
    "keywords": [
      "trolleybus"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚝",
    "name": "monorail",
    "altNames": [],
    "keywords": [
      "vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚞",
    "name": "mountain_railway",
    "altNames": [],
    "keywords": [
      "car"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚋",
    "name": "train",
    "altNames": [],
    "keywords": [
      "car",
      "tram",
      "trolleybus"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚌",
    "name": "bus",
    "altNames": [],
    "keywords": [
      "vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚍",
    "name": "oncoming_bus",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚎",
    "name": "trolleybus",
    "altNames": [],
    "keywords": [
      "tram"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚐",
    "name": "minibus",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚑",
    "name": "ambulance",
    "altNames": [],
    "keywords": [
      "vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚒",
    "name": "fire_engine",
    "altNames": [],
    "keywords": [
      "truck"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚓",
    "name": "police_car",
    "altNames": [],
    "keywords": [
      "patrol"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚔",
    "name": "oncoming_police_car",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚕",
    "name": "taxi",
    "altNames": [],
    "keywords": [
      "vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚖",
    "name": "oncoming_taxi",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚗",
    "name": "car",
    "altNames": [
      "red_car"
    ],
    "keywords": [
      "automobile"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚘",
    "name": "oncoming_automobile",
    "altNames": [],
    "keywords": [
      "car"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚙",
    "name": "blue_car",
    "altNames": [],
    "keywords": [
      "recreational",
      "sport utility",
      "sport utility vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚚",
    "name": "truck",
    "altNames": [],
    "keywords": [
      "delivery"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚛",
    "name": "articulated_lorry",
    "altNames": [],
    "keywords": [
      "semi",
      "truck"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚜",
    "name": "tractor",
    "altNames": [],
    "keywords": [
      "vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏎️",
    "name": "racing_car",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🏍️",
    "name": "racing_motorcycle",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛵",
    "name": "motor_scooter",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🦽",
    "name": "manual_wheelchair",
    "altNames": [],
    "keywords": [
      "accessibility"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🦼",
    "name": "motorized_wheelchair",
    "altNames": [],
    "keywords": [
      "accessibility"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛺",
    "name": "auto_rickshaw",
    "altNames": [],
    "keywords": [
      "tuk tuk"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚲",
    "name": "bike",
    "altNames": [],
    "keywords": [
      "bicycle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛴",
    "name": "scooter",
    "altNames": [],
    "keywords": [
      "kick"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛹",
    "name": "skateboard",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚏",
    "name": "busstop",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛣️",
    "name": "motorway",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛤️",
    "name": "railway_track",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛢️",
    "name": "oil_drum",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛽",
    "name": "fuelpump",
    "altNames": [],
    "keywords": [
      "diesel",
      "gas",
      "station"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚨",
    "name": "rotating_light",
    "altNames": [],
    "keywords": [
      "beacon",
      "car",
      "police",
      "revolving"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚥",
    "name": "traffic_light",
    "altNames": [],
    "keywords": [
      "horizontal traffic light",
      "signal"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚦",
    "name": "vertical_traffic_light",
    "altNames": [],
    "keywords": [
      "signal"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛑",
    "name": "octagonal_sign",
    "altNames": [],
    "keywords": [
      "stop"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚧",
    "name": "construction",
    "altNames": [],
    "keywords": [
      "barrier"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⚓",
    "name": "anchor",
    "altNames": [],
    "keywords": [
      "ship",
      "tool"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛵",
    "name": "boat",
    "altNames": [
      "sailboat"
    ],
    "keywords": [
      "resort",
      "sea",
      "yacht"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛶",
    "name": "canoe",
    "altNames": [],
    "keywords": [
      "boat"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚤",
    "name": "speedboat",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛳️",
    "name": "passenger_ship",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛴️",
    "name": "ferry",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛥️",
    "name": "motor_boat",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚢",
    "name": "ship",
    "altNames": [],
    "keywords": [
      "boat",
      "passenger"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "✈️",
    "name": "airplane",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛩️",
    "name": "small_airplane",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛫",
    "name": "airplane_departure",
    "altNames": [],
    "keywords": [
      "aeroplane",
      "check-in",
      "departures"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛬",
    "name": "airplane_arriving",
    "altNames": [],
    "keywords": [
      "aeroplane",
      "airplane arrival",
      "arrivals",
      "landing"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🪂",
    "name": "parachute",
    "altNames": [],
    "keywords": [
      "hang-glide",
      "parasail",
      "skydive"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "💺",
    "name": "seat",
    "altNames": [],
    "keywords": [
      "chair"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚁",
    "name": "helicopter",
    "altNames": [],
    "keywords": [
      "vehicle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚟",
    "name": "suspension_railway",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚠",
    "name": "mountain_cableway",
    "altNames": [],
    "keywords": [
      "gondola"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚡",
    "name": "aerial_tramway",
    "altNames": [],
    "keywords": [
      "cable",
      "car",
      "gondola"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛰️",
    "name": "satellite",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🚀",
    "name": "rocket",
    "altNames": [],
    "keywords": [
      "space"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛸",
    "name": "flying_saucer",
    "altNames": [],
    "keywords": [
      "ufo"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🛎️",
    "name": "bellhop_bell",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🧳",
    "name": "luggage",
    "altNames": [],
    "keywords": [
      "packing",
      "travel"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⌛",
    "name": "hourglass",
    "altNames": [],
    "keywords": [
      "hourglass done",
      "sand",
      "timer"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⏳",
    "name": "hourglass_flowing_sand",
    "altNames": [],
    "keywords": [
      "hourglass not done",
      "timer"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⌚",
    "name": "watch",
    "altNames": [],
    "keywords": [
      "clock"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⏰",
    "name": "alarm_clock",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⏱️",
    "name": "stopwatch",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⏲️",
    "name": "timer_clock",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕰️",
    "name": "mantelpiece_clock",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕛",
    "name": "clock12",
    "altNames": [],
    "keywords": [
      "00",
      "12:00",
      "o’clock",
      "twelve"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕧",
    "name": "clock1230",
    "altNames": [],
    "keywords": [
      "12:30",
      "thirty",
      "twelve",
      "twelve-thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕐",
    "name": "clock1",
    "altNames": [],
    "keywords": [
      "00",
      "1:00",
      "o’clock",
      "one"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕜",
    "name": "clock130",
    "altNames": [],
    "keywords": [
      "1:30",
      "one",
      "one-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕑",
    "name": "clock2",
    "altNames": [],
    "keywords": [
      "00",
      "2:00",
      "o’clock",
      "two"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕝",
    "name": "clock230",
    "altNames": [],
    "keywords": [
      "2:30",
      "thirty",
      "two",
      "two-thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕒",
    "name": "clock3",
    "altNames": [],
    "keywords": [
      "00",
      "3:00",
      "o’clock",
      "three"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕞",
    "name": "clock330",
    "altNames": [],
    "keywords": [
      "3:30",
      "thirty",
      "three",
      "three-thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕓",
    "name": "clock4",
    "altNames": [],
    "keywords": [
      "00",
      "4:00",
      "four",
      "o’clock"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕟",
    "name": "clock430",
    "altNames": [],
    "keywords": [
      "4:30",
      "four",
      "four-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕔",
    "name": "clock5",
    "altNames": [],
    "keywords": [
      "00",
      "5:00",
      "five",
      "o’clock"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕠",
    "name": "clock530",
    "altNames": [],
    "keywords": [
      "5:30",
      "five",
      "five-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕕",
    "name": "clock6",
    "altNames": [],
    "keywords": [
      "00",
      "6:00",
      "o’clock",
      "six"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕡",
    "name": "clock630",
    "altNames": [],
    "keywords": [
      "6:30",
      "six",
      "six-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕖",
    "name": "clock7",
    "altNames": [],
    "keywords": [
      "00",
      "7:00",
      "o’clock",
      "seven"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕢",
    "name": "clock730",
    "altNames": [],
    "keywords": [
      "7:30",
      "seven",
      "seven-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕗",
    "name": "clock8",
    "altNames": [],
    "keywords": [
      "00",
      "8:00",
      "eight",
      "o’clock"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕣",
    "name": "clock830",
    "altNames": [],
    "keywords": [
      "8:30",
      "eight",
      "eight-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕘",
    "name": "clock9",
    "altNames": [],
    "keywords": [
      "00",
      "9:00",
      "nine",
      "o’clock"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕤",
    "name": "clock930",
    "altNames": [],
    "keywords": [
      "9:30",
      "nine",
      "nine-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕙",
    "name": "clock10",
    "altNames": [],
    "keywords": [
      "00",
      "10:00",
      "o’clock",
      "ten"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕥",
    "name": "clock1030",
    "altNames": [],
    "keywords": [
      "10:30",
      "ten",
      "ten-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕚",
    "name": "clock11",
    "altNames": [],
    "keywords": [
      "00",
      "11:00",
      "eleven",
      "o’clock"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🕦",
    "name": "clock1130",
    "altNames": [],
    "keywords": [
      "11:30",
      "eleven",
      "eleven-thirty",
      "thirty"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌑",
    "name": "new_moon",
    "altNames": [],
    "keywords": [
      "dark"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌒",
    "name": "waxing_crescent_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌓",
    "name": "first_quarter_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌔",
    "name": "moon",
    "altNames": [
      "waxing_gibbous_moon"
    ],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌕",
    "name": "full_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌖",
    "name": "waning_gibbous_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌗",
    "name": "last_quarter_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌘",
    "name": "waning_crescent_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌙",
    "name": "crescent_moon",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌚",
    "name": "new_moon_with_face",
    "altNames": [],
    "keywords": [
      "new moon face"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌛",
    "name": "first_quarter_moon_with_face",
    "altNames": [],
    "keywords": [
      "first quarter moon face"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌜",
    "name": "last_quarter_moon_with_face",
    "altNames": [],
    "keywords": [
      "last quarter moon face"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌡️",
    "name": "thermometer",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "☀️",
    "name": "sunny",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌝",
    "name": "full_moon_with_face",
    "altNames": [],
    "keywords": [
      "bright"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌞",
    "name": "sun_with_face",
    "altNames": [],
    "keywords": [
      "bright"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🪐",
    "name": "ringed_planet",
    "altNames": [],
    "keywords": [
      "saturn",
      "saturnine"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⭐",
    "name": "star",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌟",
    "name": "star2",
    "altNames": [],
    "keywords": [
      "glittery",
      "glow",
      "glowing star",
      "shining",
      "sparkle"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌠",
    "name": "stars",
    "altNames": [],
    "keywords": [
      "falling",
      "shooting"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌌",
    "name": "milky_way",
    "altNames": [],
    "keywords": [
      "space"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "☁️",
    "name": "cloud",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛅",
    "name": "partly_sunny",
    "altNames": [],
    "keywords": [
      "cloud",
      "sun behind cloud"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛈️",
    "name": "thunder_cloud_and_rain",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌤️",
    "name": "mostly_sunny",
    "altNames": [
      "sun_small_cloud"
    ],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌥️",
    "name": "barely_sunny",
    "altNames": [
      "sun_behind_cloud"
    ],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌦️",
    "name": "partly_sunny_rain",
    "altNames": [
      "sun_behind_rain_cloud"
    ],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌧️",
    "name": "rain_cloud",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌨️",
    "name": "snow_cloud",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌩️",
    "name": "lightning",
    "altNames": [
      "lightning_cloud"
    ],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌪️",
    "name": "tornado",
    "altNames": [
      "tornado_cloud"
    ],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌫️",
    "name": "fog",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌬️",
    "name": "wind_blowing_face",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌀",
    "name": "cyclone",
    "altNames": [],
    "keywords": [
      "dizzy",
      "hurricane",
      "twister",
      "typhoon"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌈",
    "name": "rainbow",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌂",
    "name": "closed_umbrella",
    "altNames": [],
    "keywords": [
      "clothing",
      "rain"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "☂️",
    "name": "umbrella",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "☔",
    "name": "umbrella_with_rain_drops",
    "altNames": [],
    "keywords": [
      "clothing"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛱️",
    "name": "umbrella_on_ground",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⚡",
    "name": "zap",
    "altNames": [],
    "keywords": [
      "danger",
      "electric",
      "high voltage",
      "lightning",
      "voltage"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "❄️",
    "name": "snowflake",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "☃️",
    "name": "snowman",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "⛄",
    "name": "snowman_without_snow",
    "altNames": [],
    "keywords": [
      "cold"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "☄️",
    "name": "comet",
    "altNames": [],
    "keywords": [],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🔥",
    "name": "fire",
    "altNames": [],
    "keywords": [
      "flame",
      "tool"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "💧",
    "name": "droplet",
    "altNames": [],
    "keywords": [
      "cold",
      "comic",
      "sweat"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🌊",
    "name": "ocean",
    "altNames": [],
    "keywords": [
      "water",
      "wave"
    ],
    "category": "travel_and_places",
    "fitzpatrickScale": false
  },
  {
    "char": "🎃",
    "name": "jack_o_lantern",
    "altNames": [],
    "keywords": [
      "celebration",
      "halloween"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎄",
    "name": "christmas_tree",
    "altNames": [],
    "keywords": [
      "celebration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎆",
    "name": "fireworks",
    "altNames": [],
    "keywords": [
      "celebration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎇",
    "name": "sparkler",
    "altNames": [],
    "keywords": [
      "celebration",
      "fireworks"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🧨",
    "name": "firecracker",
    "altNames": [],
    "keywords": [
      "dynamite",
      "explosive",
      "fireworks"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "✨",
    "name": "sparkles",
    "altNames": [],
    "keywords": [
      "*",
      "star"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎈",
    "name": "balloon",
    "altNames": [],
    "keywords": [
      "celebration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎉",
    "name": "tada",
    "altNames": [],
    "keywords": [
      "celebration",
      "party",
      "popper"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎊",
    "name": "confetti_ball",
    "altNames": [],
    "keywords": [
      "celebration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎋",
    "name": "tanabata_tree",
    "altNames": [],
    "keywords": [
      "banner",
      "celebration",
      "japanese"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎍",
    "name": "bamboo",
    "altNames": [],
    "keywords": [
      "celebration",
      "japanese",
      "pine",
      "pine decoration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎎",
    "name": "dolls",
    "altNames": [],
    "keywords": [
      "celebration",
      "festival",
      "japanese",
      "japanese dolls"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎏",
    "name": "flags",
    "altNames": [],
    "keywords": [
      "carp",
      "celebration",
      "streamer"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎐",
    "name": "wind_chime",
    "altNames": [],
    "keywords": [
      "bell",
      "celebration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎑",
    "name": "rice_scene",
    "altNames": [],
    "keywords": [
      "celebration",
      "ceremony",
      "moon",
      "moon viewing ceremony"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🧧",
    "name": "red_envelope",
    "altNames": [],
    "keywords": [
      "gift",
      "good luck",
      "hóngbāo",
      "lai see",
      "money"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎀",
    "name": "ribbon",
    "altNames": [],
    "keywords": [
      "celebration"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎁",
    "name": "gift",
    "altNames": [],
    "keywords": [
      "box",
      "celebration",
      "present",
      "wrapped"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎗️",
    "name": "reminder_ribbon",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎟️",
    "name": "admission_tickets",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎫",
    "name": "ticket",
    "altNames": [],
    "keywords": [
      "admission"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎖️",
    "name": "medal",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏆",
    "name": "trophy",
    "altNames": [],
    "keywords": [
      "prize"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏅",
    "name": "sports_medal",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥇",
    "name": "first_place_medal",
    "altNames": [],
    "keywords": [
      "1st place medal",
      "gold"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥈",
    "name": "second_place_medal",
    "altNames": [],
    "keywords": [
      "2nd place medal",
      "silver"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥉",
    "name": "third_place_medal",
    "altNames": [],
    "keywords": [
      "3rd place medal",
      "bronze"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "⚽",
    "name": "soccer",
    "altNames": [],
    "keywords": [
      "ball",
      "football"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "⚾",
    "name": "baseball",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥎",
    "name": "softball",
    "altNames": [],
    "keywords": [
      "glove",
      "underarm"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏀",
    "name": "basketball",
    "altNames": [],
    "keywords": [
      "hoop"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏐",
    "name": "volleyball",
    "altNames": [],
    "keywords": [
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏈",
    "name": "football",
    "altNames": [],
    "keywords": [
      "american"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏉",
    "name": "rugby_football",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎾",
    "name": "tennis",
    "altNames": [],
    "keywords": [
      "ball",
      "racquet"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥏",
    "name": "flying_disc",
    "altNames": [],
    "keywords": [
      "ultimate"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎳",
    "name": "bowling",
    "altNames": [],
    "keywords": [
      "ball",
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏏",
    "name": "cricket_bat_and_ball",
    "altNames": [],
    "keywords": [
      "cricket game",
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏑",
    "name": "field_hockey_stick_and_ball",
    "altNames": [],
    "keywords": [
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏒",
    "name": "ice_hockey_stick_and_puck",
    "altNames": [],
    "keywords": [
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥍",
    "name": "lacrosse",
    "altNames": [],
    "keywords": [
      "ball",
      "goal",
      "stick"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏓",
    "name": "table_tennis_paddle_and_ball",
    "altNames": [],
    "keywords": [
      "bat",
      "game",
      "ping pong"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🏸",
    "name": "badminton_racquet_and_shuttlecock",
    "altNames": [],
    "keywords": [
      "birdie",
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥊",
    "name": "boxing_glove",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥋",
    "name": "martial_arts_uniform",
    "altNames": [],
    "keywords": [
      "judo",
      "karate",
      "taekwondo"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥅",
    "name": "goal_net",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "⛳",
    "name": "golf",
    "altNames": [],
    "keywords": [
      "flag in hole",
      "hole"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "⛸️",
    "name": "ice_skate",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎣",
    "name": "fishing_pole_and_fish",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🤿",
    "name": "diving_mask",
    "altNames": [],
    "keywords": [
      "scuba",
      "snorkeling"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎽",
    "name": "running_shirt_with_sash",
    "altNames": [],
    "keywords": [
      "athletics"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎿",
    "name": "ski",
    "altNames": [],
    "keywords": [
      "skis",
      "snow"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🛷",
    "name": "sled",
    "altNames": [],
    "keywords": [
      "sledge",
      "sleigh"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🥌",
    "name": "curling_stone",
    "altNames": [],
    "keywords": [
      "game",
      "rock"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎯",
    "name": "dart",
    "altNames": [],
    "keywords": [
      "bullseye",
      "direct hit",
      "game",
      "hit",
      "target"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🪀",
    "name": "yo-yo",
    "altNames": [],
    "keywords": [
      "fluctuate",
      "toy"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🪁",
    "name": "kite",
    "altNames": [],
    "keywords": [
      "fly",
      "soar"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🔫",
    "name": "gun",
    "altNames": [],
    "keywords": [
      "handgun",
      "pistol",
      "revolver",
      "tool",
      "water",
      "weapon"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎱",
    "name": "8ball",
    "altNames": [],
    "keywords": [
      "billiard",
      "eight",
      "game",
      "pool 8 ball"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🔮",
    "name": "crystal_ball",
    "altNames": [],
    "keywords": [
      "fairy tale",
      "fantasy",
      "fortune",
      "tool"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎮",
    "name": "video_game",
    "altNames": [],
    "keywords": [
      "controller"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🕹️",
    "name": "joystick",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎰",
    "name": "slot_machine",
    "altNames": [],
    "keywords": [
      "game"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎲",
    "name": "game_die",
    "altNames": [],
    "keywords": [
      "dice"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🧩",
    "name": "jigsaw",
    "altNames": [],
    "keywords": [
      "clue",
      "interlocking",
      "piece",
      "puzzle"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🧸",
    "name": "teddy_bear",
    "altNames": [],
    "keywords": [
      "plaything",
      "plush",
      "stuffed",
      "toy"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "♠️",
    "name": "spades",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "♥️",
    "name": "hearts",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "♦️",
    "name": "diamonds",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "♣️",
    "name": "clubs",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "♟️",
    "name": "chess_pawn",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🃏",
    "name": "black_joker",
    "altNames": [],
    "keywords": [
      "card",
      "game",
      "wildcard"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🀄",
    "name": "mahjong",
    "altNames": [],
    "keywords": [
      "game",
      "mahjong red dragon",
      "red"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎴",
    "name": "flower_playing_cards",
    "altNames": [],
    "keywords": [
      "game",
      "japanese"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎭",
    "name": "performing_arts",
    "altNames": [],
    "keywords": [
      "mask",
      "theater",
      "theatre"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🖼️",
    "name": "frame_with_picture",
    "altNames": [],
    "keywords": [],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🎨",
    "name": "art",
    "altNames": [],
    "keywords": [
      "artist palette",
      "museum",
      "painting",
      "palette"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🧵",
    "name": "thread",
    "altNames": [],
    "keywords": [
      "needle",
      "sewing",
      "spool",
      "string"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "🧶",
    "name": "yarn",
    "altNames": [],
    "keywords": [
      "ball",
      "crochet",
      "knit"
    ],
    "category": "activity",
    "fitzpatrickScale": false
  },
  {
    "char": "👓",
    "name": "eyeglasses",
    "altNames": [],
    "keywords": [
      "clothing",
      "eyewear"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🕶️",
    "name": "dark_sunglasses",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🥽",
    "name": "goggles",
    "altNames": [],
    "keywords": [
      "eye protection",
      "swimming",
      "welding"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🥼",
    "name": "lab_coat",
    "altNames": [],
    "keywords": [
      "doctor",
      "experiment",
      "scientist"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🦺",
    "name": "safety_vest",
    "altNames": [],
    "keywords": [
      "emergency"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👔",
    "name": "necktie",
    "altNames": [],
    "keywords": [
      "clothing"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👕",
    "name": "shirt",
    "altNames": [
      "tshirt"
    ],
    "keywords": [
      "clothing"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👖",
    "name": "jeans",
    "altNames": [],
    "keywords": [
      "clothing",
      "pants",
      "trousers"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧣",
    "name": "scarf",
    "altNames": [],
    "keywords": [
      "neck"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧤",
    "name": "gloves",
    "altNames": [],
    "keywords": [
      "hand"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧥",
    "name": "coat",
    "altNames": [],
    "keywords": [
      "jacket"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧦",
    "name": "socks",
    "altNames": [],
    "keywords": [
      "stocking"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👗",
    "name": "dress",
    "altNames": [],
    "keywords": [
      "clothing"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👘",
    "name": "kimono",
    "altNames": [],
    "keywords": [
      "clothing"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🥻",
    "name": "sari",
    "altNames": [],
    "keywords": [
      "clothing",
      "dress"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩱",
    "name": "one-piece_swimsuit",
    "altNames": [],
    "keywords": [
      "bathing suit"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩲",
    "name": "briefs",
    "altNames": [],
    "keywords": [
      "bathing suit",
      "one-piece",
      "swimsuit",
      "underwear"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩳",
    "name": "shorts",
    "altNames": [],
    "keywords": [
      "bathing suit",
      "pants",
      "underwear"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👙",
    "name": "bikini",
    "altNames": [],
    "keywords": [
      "clothing",
      "swim"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👚",
    "name": "womans_clothes",
    "altNames": [],
    "keywords": [
      "clothing",
      "woman’s clothes"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👛",
    "name": "purse",
    "altNames": [],
    "keywords": [
      "clothing",
      "coin"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👜",
    "name": "handbag",
    "altNames": [],
    "keywords": [
      "clothing",
      "purse"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👝",
    "name": "pouch",
    "altNames": [],
    "keywords": [
      "bag",
      "clothing",
      "clutch bag"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛍️",
    "name": "shopping_bags",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎒",
    "name": "school_satchel",
    "altNames": [],
    "keywords": [
      "backpack",
      "bag",
      "rucksack"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👞",
    "name": "mans_shoe",
    "altNames": [
      "shoe"
    ],
    "keywords": [
      "clothing",
      "man’s shoe"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👟",
    "name": "athletic_shoe",
    "altNames": [],
    "keywords": [
      "clothing",
      "running shoe",
      "sneaker"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🥾",
    "name": "hiking_boot",
    "altNames": [],
    "keywords": [
      "backpacking",
      "camping"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🥿",
    "name": "womans_flat_shoe",
    "altNames": [],
    "keywords": [
      "ballet flat",
      "slip-on",
      "slipper"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👠",
    "name": "high_heel",
    "altNames": [],
    "keywords": [
      "clothing",
      "high-heeled shoe",
      "shoe",
      "woman"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👡",
    "name": "sandal",
    "altNames": [],
    "keywords": [
      "clothing",
      "shoe",
      "woman",
      "woman’s sandal"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩰",
    "name": "ballet_shoes",
    "altNames": [],
    "keywords": [
      "dance"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👢",
    "name": "boot",
    "altNames": [],
    "keywords": [
      "clothing",
      "shoe",
      "woman",
      "woman’s boot"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👑",
    "name": "crown",
    "altNames": [],
    "keywords": [
      "clothing",
      "king",
      "queen"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "👒",
    "name": "womans_hat",
    "altNames": [],
    "keywords": [
      "clothing",
      "woman’s hat"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎩",
    "name": "tophat",
    "altNames": [],
    "keywords": [
      "clothing"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎓",
    "name": "mortar_board",
    "altNames": [],
    "keywords": [
      "cap",
      "celebration",
      "clothing",
      "graduation",
      "hat"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧢",
    "name": "billed_cap",
    "altNames": [],
    "keywords": [
      "baseball cap"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⛑️",
    "name": "helmet_with_white_cross",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📿",
    "name": "prayer_beads",
    "altNames": [],
    "keywords": [
      "clothing",
      "necklace",
      "religion"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💄",
    "name": "lipstick",
    "altNames": [],
    "keywords": [
      "cosmetics",
      "makeup"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💍",
    "name": "ring",
    "altNames": [],
    "keywords": [
      "diamond"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💎",
    "name": "gem",
    "altNames": [],
    "keywords": [
      "diamond",
      "gem stone",
      "jewel"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔇",
    "name": "mute",
    "altNames": [],
    "keywords": [
      "muted speaker",
      "quiet",
      "silent",
      "speaker"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔈",
    "name": "speaker",
    "altNames": [],
    "keywords": [
      "soft",
      "speaker low volume"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔉",
    "name": "sound",
    "altNames": [],
    "keywords": [
      "medium",
      "speaker medium volume"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔊",
    "name": "loud_sound",
    "altNames": [],
    "keywords": [
      "speaker high volume"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📢",
    "name": "loudspeaker",
    "altNames": [],
    "keywords": [
      "public address"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📣",
    "name": "mega",
    "altNames": [],
    "keywords": [
      "cheering",
      "megaphone"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📯",
    "name": "postal_horn",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔔",
    "name": "bell",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔕",
    "name": "no_bell",
    "altNames": [],
    "keywords": [
      "bell with slash",
      "forbidden",
      "mute",
      "quiet",
      "silent"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎼",
    "name": "musical_score",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎵",
    "name": "musical_note",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎶",
    "name": "notes",
    "altNames": [],
    "keywords": [
      "music",
      "musical notes"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎙️",
    "name": "studio_microphone",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎚️",
    "name": "level_slider",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎛️",
    "name": "control_knobs",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎤",
    "name": "microphone",
    "altNames": [],
    "keywords": [
      "karaoke"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎧",
    "name": "headphones",
    "altNames": [],
    "keywords": [
      "earbud"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📻",
    "name": "radio",
    "altNames": [],
    "keywords": [
      "video"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎷",
    "name": "saxophone",
    "altNames": [],
    "keywords": [
      "instrument",
      "music"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎸",
    "name": "guitar",
    "altNames": [],
    "keywords": [
      "instrument",
      "music"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎹",
    "name": "musical_keyboard",
    "altNames": [],
    "keywords": [
      "instrument",
      "piano"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎺",
    "name": "trumpet",
    "altNames": [],
    "keywords": [
      "instrument",
      "music"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎻",
    "name": "violin",
    "altNames": [],
    "keywords": [
      "instrument",
      "music"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🪕",
    "name": "banjo",
    "altNames": [],
    "keywords": [
      "music",
      "stringed"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🥁",
    "name": "drum_with_drumsticks",
    "altNames": [],
    "keywords": [
      "music"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📱",
    "name": "iphone",
    "altNames": [],
    "keywords": [
      "cell",
      "mobile",
      "telephone"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📲",
    "name": "calling",
    "altNames": [],
    "keywords": [
      "arrow",
      "cell",
      "mobile",
      "mobile phone with arrow",
      "phone",
      "receive"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "☎️",
    "name": "phone",
    "altNames": [
      "telephone"
    ],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📞",
    "name": "telephone_receiver",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📟",
    "name": "pager",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📠",
    "name": "fax",
    "altNames": [],
    "keywords": [
      "fax machine"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔋",
    "name": "battery",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔌",
    "name": "electric_plug",
    "altNames": [],
    "keywords": [
      "electricity"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💻",
    "name": "computer",
    "altNames": [],
    "keywords": [
      "laptop",
      "pc",
      "personal"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖥️",
    "name": "desktop_computer",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖨️",
    "name": "printer",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⌨️",
    "name": "keyboard",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖱️",
    "name": "three_button_mouse",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖲️",
    "name": "trackball",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💽",
    "name": "minidisc",
    "altNames": [],
    "keywords": [
      "computer",
      "disk",
      "minidisk",
      "optical"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💾",
    "name": "floppy_disk",
    "altNames": [],
    "keywords": [
      "computer"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💿",
    "name": "cd",
    "altNames": [],
    "keywords": [
      "computer",
      "disk",
      "optical"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📀",
    "name": "dvd",
    "altNames": [],
    "keywords": [
      "blu-ray",
      "computer",
      "disk",
      "optical"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧮",
    "name": "abacus",
    "altNames": [],
    "keywords": [
      "calculation"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎥",
    "name": "movie_camera",
    "altNames": [],
    "keywords": [
      "cinema"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎞️",
    "name": "film_frames",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📽️",
    "name": "film_projector",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🎬",
    "name": "clapper",
    "altNames": [],
    "keywords": [
      "clapper board",
      "movie"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📺",
    "name": "tv",
    "altNames": [],
    "keywords": [
      "television",
      "video"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📷",
    "name": "camera",
    "altNames": [],
    "keywords": [
      "video"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📸",
    "name": "camera_with_flash",
    "altNames": [],
    "keywords": [
      "video"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📹",
    "name": "video_camera",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📼",
    "name": "vhs",
    "altNames": [],
    "keywords": [
      "tape",
      "video",
      "videocassette"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔍",
    "name": "mag",
    "altNames": [],
    "keywords": [
      "glass",
      "magnifying",
      "magnifying glass tilted left",
      "search",
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔎",
    "name": "mag_right",
    "altNames": [],
    "keywords": [
      "glass",
      "magnifying",
      "magnifying glass tilted right",
      "search",
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🕯️",
    "name": "candle",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💡",
    "name": "bulb",
    "altNames": [],
    "keywords": [
      "comic",
      "electric",
      "idea",
      "light"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔦",
    "name": "flashlight",
    "altNames": [],
    "keywords": [
      "electric",
      "tool",
      "torch"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🏮",
    "name": "izakaya_lantern",
    "altNames": [
      "lantern"
    ],
    "keywords": [
      "bar",
      "light",
      "red",
      "red paper lantern"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🪔",
    "name": "diya_lamp",
    "altNames": [],
    "keywords": [
      "oil"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📔",
    "name": "notebook_with_decorative_cover",
    "altNames": [],
    "keywords": [
      "decorated"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📕",
    "name": "closed_book",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📖",
    "name": "book",
    "altNames": [
      "open_book"
    ],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📗",
    "name": "green_book",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📘",
    "name": "blue_book",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📙",
    "name": "orange_book",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📚",
    "name": "books",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📓",
    "name": "notebook",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📒",
    "name": "ledger",
    "altNames": [],
    "keywords": [
      "notebook"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📃",
    "name": "page_with_curl",
    "altNames": [],
    "keywords": [
      "document"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📜",
    "name": "scroll",
    "altNames": [],
    "keywords": [
      "paper"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📄",
    "name": "page_facing_up",
    "altNames": [],
    "keywords": [
      "document"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📰",
    "name": "newspaper",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗞️",
    "name": "rolled_up_newspaper",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📑",
    "name": "bookmark_tabs",
    "altNames": [],
    "keywords": [
      "marker"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔖",
    "name": "bookmark",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🏷️",
    "name": "label",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💰",
    "name": "moneybag",
    "altNames": [],
    "keywords": [
      "dollar"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💴",
    "name": "yen",
    "altNames": [],
    "keywords": [
      "banknote",
      "bill",
      "currency",
      "money",
      "note"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💵",
    "name": "dollar",
    "altNames": [],
    "keywords": [
      "banknote",
      "bill",
      "currency",
      "money",
      "note"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💶",
    "name": "euro",
    "altNames": [],
    "keywords": [
      "banknote",
      "bill",
      "currency",
      "money",
      "note"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💷",
    "name": "pound",
    "altNames": [],
    "keywords": [
      "banknote",
      "bill",
      "currency",
      "money",
      "note"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💸",
    "name": "money_with_wings",
    "altNames": [],
    "keywords": [
      "banknote",
      "bill",
      "fly"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💳",
    "name": "credit_card",
    "altNames": [],
    "keywords": [
      "money"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧾",
    "name": "receipt",
    "altNames": [],
    "keywords": [
      "accounting",
      "bookkeeping",
      "evidence",
      "proof"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💹",
    "name": "chart",
    "altNames": [],
    "keywords": [
      "chart increasing with yen",
      "graph",
      "growth",
      "money",
      "yen"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "✉️",
    "name": "email",
    "altNames": [
      "envelope"
    ],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📧",
    "name": "e-mail",
    "altNames": [],
    "keywords": [
      "letter"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📨",
    "name": "incoming_envelope",
    "altNames": [],
    "keywords": [
      "e-mail",
      "email",
      "letter",
      "receive"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📩",
    "name": "envelope_with_arrow",
    "altNames": [],
    "keywords": [
      "e-mail",
      "email",
      "outgoing"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📤",
    "name": "outbox_tray",
    "altNames": [],
    "keywords": [
      "letter",
      "mail",
      "sent"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📥",
    "name": "inbox_tray",
    "altNames": [],
    "keywords": [
      "letter",
      "mail",
      "receive"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📦",
    "name": "package",
    "altNames": [],
    "keywords": [
      "box",
      "parcel"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📫",
    "name": "mailbox",
    "altNames": [],
    "keywords": [
      "closed",
      "closed mailbox with raised flag",
      "postbox"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📪",
    "name": "mailbox_closed",
    "altNames": [],
    "keywords": [
      "closed mailbox with lowered flag",
      "lowered",
      "postbox"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📬",
    "name": "mailbox_with_mail",
    "altNames": [],
    "keywords": [
      "open",
      "open mailbox with raised flag",
      "postbox"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📭",
    "name": "mailbox_with_no_mail",
    "altNames": [],
    "keywords": [
      "lowered",
      "open",
      "open mailbox with lowered flag",
      "postbox"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📮",
    "name": "postbox",
    "altNames": [],
    "keywords": [
      "mail",
      "mailbox"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗳️",
    "name": "ballot_box_with_ballot",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "✏️",
    "name": "pencil2",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "✒️",
    "name": "black_nib",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖋️",
    "name": "lower_left_fountain_pen",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖊️",
    "name": "lower_left_ballpoint_pen",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖌️",
    "name": "lower_left_paintbrush",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖍️",
    "name": "lower_left_crayon",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📝",
    "name": "memo",
    "altNames": [
      "pencil"
    ],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💼",
    "name": "briefcase",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📁",
    "name": "file_folder",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📂",
    "name": "open_file_folder",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗂️",
    "name": "card_index_dividers",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📅",
    "name": "date",
    "altNames": [],
    "keywords": [
      "calendar"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📆",
    "name": "calendar",
    "altNames": [],
    "keywords": [
      "tear-off calendar"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗒️",
    "name": "spiral_note_pad",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗓️",
    "name": "spiral_calendar_pad",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📇",
    "name": "card_index",
    "altNames": [],
    "keywords": [
      "rolodex"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📈",
    "name": "chart_with_upwards_trend",
    "altNames": [],
    "keywords": [
      "chart increasing",
      "graph",
      "growth"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📉",
    "name": "chart_with_downwards_trend",
    "altNames": [],
    "keywords": [
      "chart decreasing",
      "graph"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📊",
    "name": "bar_chart",
    "altNames": [],
    "keywords": [
      "graph"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📋",
    "name": "clipboard",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📌",
    "name": "pushpin",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📍",
    "name": "round_pushpin",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📎",
    "name": "paperclip",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🖇️",
    "name": "linked_paperclips",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📏",
    "name": "straight_ruler",
    "altNames": [],
    "keywords": [
      "straight edge"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📐",
    "name": "triangular_ruler",
    "altNames": [],
    "keywords": [
      "set",
      "triangle"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "✂️",
    "name": "scissors",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗃️",
    "name": "card_file_box",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗄️",
    "name": "file_cabinet",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗑️",
    "name": "wastebasket",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔒",
    "name": "lock",
    "altNames": [],
    "keywords": [
      "closed",
      "locked"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔓",
    "name": "unlock",
    "altNames": [],
    "keywords": [
      "open",
      "unlocked"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔏",
    "name": "lock_with_ink_pen",
    "altNames": [],
    "keywords": [
      "locked with pen",
      "nib",
      "privacy"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔐",
    "name": "closed_lock_with_key",
    "altNames": [],
    "keywords": [
      "locked with key",
      "secure"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔑",
    "name": "key",
    "altNames": [],
    "keywords": [
      "lock",
      "password"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗝️",
    "name": "old_key",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔨",
    "name": "hammer",
    "altNames": [],
    "keywords": [
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🪓",
    "name": "axe",
    "altNames": [],
    "keywords": [
      "chop",
      "hatchet",
      "split",
      "wood"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⛏️",
    "name": "pick",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚒️",
    "name": "hammer_and_pick",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛠️",
    "name": "hammer_and_wrench",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗡️",
    "name": "dagger_knife",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚔️",
    "name": "crossed_swords",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💣",
    "name": "bomb",
    "altNames": [],
    "keywords": [
      "comic"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🏹",
    "name": "bow_and_arrow",
    "altNames": [],
    "keywords": [
      "archer",
      "sagittarius",
      "zodiac"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛡️",
    "name": "shield",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔧",
    "name": "wrench",
    "altNames": [],
    "keywords": [
      "spanner",
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔩",
    "name": "nut_and_bolt",
    "altNames": [],
    "keywords": [
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚙️",
    "name": "gear",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗜️",
    "name": "compression",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚖️",
    "name": "scales",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🦯",
    "name": "probing_cane",
    "altNames": [],
    "keywords": [
      "accessibility",
      "blind",
      "white cane"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔗",
    "name": "link",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⛓️",
    "name": "chains",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧰",
    "name": "toolbox",
    "altNames": [],
    "keywords": [
      "chest",
      "mechanic"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧲",
    "name": "magnet",
    "altNames": [],
    "keywords": [
      "attraction",
      "horseshoe",
      "magnetic"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚗️",
    "name": "alembic",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧪",
    "name": "test_tube",
    "altNames": [],
    "keywords": [
      "chemist",
      "chemistry",
      "experiment",
      "lab",
      "science"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧫",
    "name": "petri_dish",
    "altNames": [],
    "keywords": [
      "bacteria",
      "biologist",
      "biology",
      "culture",
      "lab"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧬",
    "name": "dna",
    "altNames": [],
    "keywords": [
      "biologist",
      "evolution",
      "gene",
      "genetics",
      "life"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔬",
    "name": "microscope",
    "altNames": [],
    "keywords": [
      "science",
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🔭",
    "name": "telescope",
    "altNames": [],
    "keywords": [
      "science",
      "tool"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "📡",
    "name": "satellite_antenna",
    "altNames": [],
    "keywords": [
      "dish"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💉",
    "name": "syringe",
    "altNames": [],
    "keywords": [
      "medicine",
      "needle",
      "shot",
      "sick"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩸",
    "name": "drop_of_blood",
    "altNames": [],
    "keywords": [
      "bleed",
      "blood donation",
      "injury",
      "medicine",
      "menstruation"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "💊",
    "name": "pill",
    "altNames": [],
    "keywords": [
      "doctor",
      "medicine",
      "sick"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩹",
    "name": "adhesive_bandage",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🩺",
    "name": "stethoscope",
    "altNames": [],
    "keywords": [
      "doctor",
      "heart",
      "medicine"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🚪",
    "name": "door",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛏️",
    "name": "bed",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛋️",
    "name": "couch_and_lamp",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🪑",
    "name": "chair",
    "altNames": [],
    "keywords": [
      "seat",
      "sit"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🚽",
    "name": "toilet",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🚿",
    "name": "shower",
    "altNames": [],
    "keywords": [
      "water"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛁",
    "name": "bathtub",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🪒",
    "name": "razor",
    "altNames": [],
    "keywords": [
      "sharp",
      "shave"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧴",
    "name": "lotion_bottle",
    "altNames": [],
    "keywords": [
      "moisturizer",
      "shampoo",
      "sunscreen"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧷",
    "name": "safety_pin",
    "altNames": [],
    "keywords": [
      "diaper",
      "punk rock"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧹",
    "name": "broom",
    "altNames": [],
    "keywords": [
      "cleaning",
      "sweeping",
      "witch"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧺",
    "name": "basket",
    "altNames": [],
    "keywords": [
      "farming",
      "laundry",
      "picnic"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧻",
    "name": "roll_of_paper",
    "altNames": [],
    "keywords": [
      "paper towels",
      "toilet paper"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧼",
    "name": "soap",
    "altNames": [],
    "keywords": [
      "bar",
      "bathing",
      "cleaning",
      "lather",
      "soapdish"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧽",
    "name": "sponge",
    "altNames": [],
    "keywords": [
      "absorbing",
      "cleaning",
      "porous"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧯",
    "name": "fire_extinguisher",
    "altNames": [],
    "keywords": [
      "quench"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🛒",
    "name": "shopping_trolley",
    "altNames": [],
    "keywords": [
      "cart"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🚬",
    "name": "smoking",
    "altNames": [],
    "keywords": [
      "cigarette"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚰️",
    "name": "coffin",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "⚱️",
    "name": "funeral_urn",
    "altNames": [],
    "keywords": [],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🧿",
    "name": "nazar_amulet",
    "altNames": [],
    "keywords": [
      "bead",
      "charm",
      "evil-eye",
      "talisman"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🗿",
    "name": "moyai",
    "altNames": [],
    "keywords": [
      "face",
      "moai",
      "statue"
    ],
    "category": "objects",
    "fitzpatrickScale": false
  },
  {
    "char": "🏧",
    "name": "atm",
    "altNames": [],
    "keywords": [
      "atm sign",
      "automated",
      "bank",
      "teller"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚮",
    "name": "put_litter_in_its_place",
    "altNames": [],
    "keywords": [
      "litter bin",
      "litter in bin sign"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚰",
    "name": "potable_water",
    "altNames": [],
    "keywords": [
      "drinking"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♿",
    "name": "wheelchair",
    "altNames": [],
    "keywords": [
      "access",
      "wheelchair symbol"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚹",
    "name": "mens",
    "altNames": [],
    "keywords": [
      "bathroom",
      "lavatory",
      "man",
      "men’s room",
      "restroom",
      "toilet",
      "wc"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚺",
    "name": "womens",
    "altNames": [],
    "keywords": [
      "bathroom",
      "lavatory",
      "restroom",
      "toilet",
      "wc",
      "woman",
      "women’s room"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚻",
    "name": "restroom",
    "altNames": [],
    "keywords": [
      "bathroom",
      "lavatory",
      "toilet",
      "wc"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚼",
    "name": "baby_symbol",
    "altNames": [],
    "keywords": [
      "changing"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚾",
    "name": "wc",
    "altNames": [],
    "keywords": [
      "bathroom",
      "closet",
      "lavatory",
      "restroom",
      "toilet",
      "water"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🛂",
    "name": "passport_control",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🛃",
    "name": "customs",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🛄",
    "name": "baggage_claim",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🛅",
    "name": "left_luggage",
    "altNames": [],
    "keywords": [
      "baggage",
      "locker"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⚠️",
    "name": "warning",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚸",
    "name": "children_crossing",
    "altNames": [],
    "keywords": [
      "pedestrian",
      "traffic"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⛔",
    "name": "no_entry",
    "altNames": [],
    "keywords": [
      "forbidden",
      "not",
      "prohibited",
      "traffic"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚫",
    "name": "no_entry_sign",
    "altNames": [],
    "keywords": [
      "forbidden",
      "not",
      "prohibited"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚳",
    "name": "no_bicycles",
    "altNames": [],
    "keywords": [
      "bike",
      "forbidden",
      "prohibited"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚭",
    "name": "no_smoking",
    "altNames": [],
    "keywords": [
      "forbidden",
      "not",
      "prohibited"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚯",
    "name": "do_not_litter",
    "altNames": [],
    "keywords": [
      "forbidden",
      "no littering",
      "prohibited"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚱",
    "name": "non-potable_water",
    "altNames": [],
    "keywords": [
      "non-drinking"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🚷",
    "name": "no_pedestrians",
    "altNames": [],
    "keywords": [
      "forbidden",
      "not",
      "prohibited"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "📵",
    "name": "no_mobile_phones",
    "altNames": [],
    "keywords": [
      "cell",
      "forbidden"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔞",
    "name": "underage",
    "altNames": [],
    "keywords": [
      "18",
      "age restriction",
      "eighteen",
      "no one under eighteen",
      "prohibited"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☢️",
    "name": "radioactive_sign",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☣️",
    "name": "biohazard_sign",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⬆️",
    "name": "arrow_up",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↗️",
    "name": "arrow_upper_right",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "➡️",
    "name": "arrow_right",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↘️",
    "name": "arrow_lower_right",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⬇️",
    "name": "arrow_down",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↙️",
    "name": "arrow_lower_left",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⬅️",
    "name": "arrow_left",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↖️",
    "name": "arrow_upper_left",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↕️",
    "name": "arrow_up_down",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↔️",
    "name": "left_right_arrow",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↩️",
    "name": "leftwards_arrow_with_hook",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "↪️",
    "name": "arrow_right_hook",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⤴️",
    "name": "arrow_heading_up",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⤵️",
    "name": "arrow_heading_down",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔃",
    "name": "arrows_clockwise",
    "altNames": [],
    "keywords": [
      "clockwise vertical arrows",
      "reload"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔄",
    "name": "arrows_counterclockwise",
    "altNames": [],
    "keywords": [
      "anticlockwise",
      "counterclockwise arrows button",
      "withershins"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔙",
    "name": "back",
    "altNames": [],
    "keywords": [
      "arrow"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔚",
    "name": "end",
    "altNames": [],
    "keywords": [
      "arrow"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔛",
    "name": "on",
    "altNames": [],
    "keywords": [
      "arrow",
      "mark",
      "on!"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔜",
    "name": "soon",
    "altNames": [],
    "keywords": [
      "arrow"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔝",
    "name": "top",
    "altNames": [],
    "keywords": [
      "arrow",
      "up"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🛐",
    "name": "place_of_worship",
    "altNames": [],
    "keywords": [
      "religion"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⚛️",
    "name": "atom_symbol",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🕉️",
    "name": "om_symbol",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✡️",
    "name": "star_of_david",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☸️",
    "name": "wheel_of_dharma",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☯️",
    "name": "yin_yang",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✝️",
    "name": "latin_cross",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☦️",
    "name": "orthodox_cross",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☪️",
    "name": "star_and_crescent",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☮️",
    "name": "peace_symbol",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🕎",
    "name": "menorah_with_nine_branches",
    "altNames": [],
    "keywords": [
      "candelabrum",
      "candlestick",
      "religion"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔯",
    "name": "six_pointed_star",
    "altNames": [],
    "keywords": [
      "dotted six-pointed star",
      "fortune"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♈",
    "name": "aries",
    "altNames": [],
    "keywords": [
      "ram",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♉",
    "name": "taurus",
    "altNames": [],
    "keywords": [
      "bull",
      "ox",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♊",
    "name": "gemini",
    "altNames": [],
    "keywords": [
      "twins",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♋",
    "name": "cancer",
    "altNames": [],
    "keywords": [
      "crab",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♌",
    "name": "leo",
    "altNames": [],
    "keywords": [
      "lion",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♍",
    "name": "virgo",
    "altNames": [],
    "keywords": [
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♎",
    "name": "libra",
    "altNames": [],
    "keywords": [
      "balance",
      "justice",
      "scales",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♏",
    "name": "scorpius",
    "altNames": [],
    "keywords": [
      "scorpio",
      "scorpion",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♐",
    "name": "sagittarius",
    "altNames": [],
    "keywords": [
      "archer",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♑",
    "name": "capricorn",
    "altNames": [],
    "keywords": [
      "goat",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♒",
    "name": "aquarius",
    "altNames": [],
    "keywords": [
      "bearer",
      "water",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♓",
    "name": "pisces",
    "altNames": [],
    "keywords": [
      "fish",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⛎",
    "name": "ophiuchus",
    "altNames": [],
    "keywords": [
      "bearer",
      "serpent",
      "snake",
      "zodiac"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔀",
    "name": "twisted_rightwards_arrows",
    "altNames": [],
    "keywords": [
      "crossed",
      "shuffle tracks button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔁",
    "name": "repeat",
    "altNames": [],
    "keywords": [
      "arrow",
      "clockwise",
      "repeat button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔂",
    "name": "repeat_one",
    "altNames": [],
    "keywords": [
      "arrow",
      "clockwise",
      "once",
      "repeat single button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "▶️",
    "name": "arrow_forward",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏩",
    "name": "fast_forward",
    "altNames": [],
    "keywords": [
      "arrow",
      "double",
      "fast-forward button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏭️",
    "name": "black_right_pointing_double_triangle_with_vertical_bar",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏯️",
    "name": "black_right_pointing_triangle_with_double_vertical_bar",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "◀️",
    "name": "arrow_backward",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏪",
    "name": "rewind",
    "altNames": [],
    "keywords": [
      "arrow",
      "double",
      "fast reverse button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏮️",
    "name": "black_left_pointing_double_triangle_with_vertical_bar",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔼",
    "name": "arrow_up_small",
    "altNames": [],
    "keywords": [
      "button",
      "upwards button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏫",
    "name": "arrow_double_up",
    "altNames": [],
    "keywords": [
      "fast up button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔽",
    "name": "arrow_down_small",
    "altNames": [],
    "keywords": [
      "button",
      "downwards button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏬",
    "name": "arrow_double_down",
    "altNames": [],
    "keywords": [
      "fast down button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏸️",
    "name": "double_vertical_bar",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏹️",
    "name": "black_square_for_stop",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏺️",
    "name": "black_circle_for_record",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⏏️",
    "name": "eject",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🎦",
    "name": "cinema",
    "altNames": [],
    "keywords": [
      "camera",
      "film",
      "movie"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔅",
    "name": "low_brightness",
    "altNames": [],
    "keywords": [
      "dim",
      "dim button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔆",
    "name": "high_brightness",
    "altNames": [],
    "keywords": [
      "bright button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "📶",
    "name": "signal_strength",
    "altNames": [],
    "keywords": [
      "antenna",
      "antenna bars",
      "bar",
      "cell",
      "mobile",
      "phone"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "📳",
    "name": "vibration_mode",
    "altNames": [],
    "keywords": [
      "cell",
      "mobile",
      "phone",
      "telephone"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "📴",
    "name": "mobile_phone_off",
    "altNames": [],
    "keywords": [
      "cell",
      "telephone"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♀️",
    "name": "female_sign",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♂️",
    "name": "male_sign",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✖️",
    "name": "heavy_multiplication_x",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "➕",
    "name": "heavy_plus_sign",
    "altNames": [],
    "keywords": [
      "+",
      "math"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "➖",
    "name": "heavy_minus_sign",
    "altNames": [],
    "keywords": [
      "−",
      "math"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "➗",
    "name": "heavy_division_sign",
    "altNames": [],
    "keywords": [
      "÷",
      "divide",
      "math"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♾️",
    "name": "infinity",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "‼️",
    "name": "bangbang",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⁉️",
    "name": "interrobang",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❓",
    "name": "question",
    "altNames": [],
    "keywords": [
      "?",
      "mark",
      "punctuation",
      "red question mark"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❔",
    "name": "grey_question",
    "altNames": [],
    "keywords": [
      "?",
      "mark",
      "outlined",
      "punctuation",
      "white question mark"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❕",
    "name": "grey_exclamation",
    "altNames": [],
    "keywords": [
      "!",
      "mark",
      "outlined",
      "punctuation",
      "white exclamation mark"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❗",
    "name": "exclamation",
    "altNames": [
      "heavy_exclamation_mark"
    ],
    "keywords": [
      "!",
      "punctuation",
      "red exclamation mark"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "〰️",
    "name": "wavy_dash",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "💱",
    "name": "currency_exchange",
    "altNames": [],
    "keywords": [
      "bank",
      "money"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "💲",
    "name": "heavy_dollar_sign",
    "altNames": [],
    "keywords": [
      "currency",
      "money"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⚕️",
    "name": "medical_symbol",
    "altNames": [
      "staff_of_aesculapius"
    ],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "♻️",
    "name": "recycle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⚜️",
    "name": "fleur_de_lis",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔱",
    "name": "trident",
    "altNames": [],
    "keywords": [
      "anchor",
      "emblem",
      "ship",
      "tool"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "📛",
    "name": "name_badge",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔰",
    "name": "beginner",
    "altNames": [],
    "keywords": [
      "chevron",
      "japanese",
      "japanese symbol for beginner",
      "leaf"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⭕",
    "name": "o",
    "altNames": [],
    "keywords": [
      "circle",
      "hollow red circle",
      "large",
      "red"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✅",
    "name": "white_check_mark",
    "altNames": [],
    "keywords": [
      "✓",
      "button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "☑️",
    "name": "ballot_box_with_check",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✔️",
    "name": "heavy_check_mark",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❌",
    "name": "x",
    "altNames": [],
    "keywords": [
      "×",
      "cancel",
      "cross",
      "mark",
      "multiplication",
      "multiply"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❎",
    "name": "negative_squared_cross_mark",
    "altNames": [],
    "keywords": [
      "×",
      "cross mark button",
      "x"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "➰",
    "name": "curly_loop",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "➿",
    "name": "loop",
    "altNames": [],
    "keywords": [
      "curl",
      "double",
      "double curly loop"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "〽️",
    "name": "part_alternation_mark",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✳️",
    "name": "eight_spoked_asterisk",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "✴️",
    "name": "eight_pointed_black_star",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "❇️",
    "name": "sparkle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "©️",
    "name": "copyright",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "®️",
    "name": "registered",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "™️",
    "name": "tm",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "#️⃣",
    "name": "hash",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "*️⃣",
    "name": "keycap_star",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "0️⃣",
    "name": "zero",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "1️⃣",
    "name": "one",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "2️⃣",
    "name": "two",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "3️⃣",
    "name": "three",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "4️⃣",
    "name": "four",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "5️⃣",
    "name": "five",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "6️⃣",
    "name": "six",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "7️⃣",
    "name": "seven",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "8️⃣",
    "name": "eight",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "9️⃣",
    "name": "nine",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔟",
    "name": "keycap_ten",
    "altNames": [],
    "keywords": [
      "keycap: 10"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔠",
    "name": "capital_abcd",
    "altNames": [],
    "keywords": [
      "input",
      "latin",
      "letters",
      "uppercase"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔡",
    "name": "abcd",
    "altNames": [],
    "keywords": [
      "input",
      "latin",
      "letters",
      "lowercase"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔢",
    "name": "1234",
    "altNames": [],
    "keywords": [
      "input",
      "numbers"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔣",
    "name": "symbols",
    "altNames": [],
    "keywords": [
      "〒♪&%",
      "input",
      "input symbols"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔤",
    "name": "abc",
    "altNames": [],
    "keywords": [
      "alphabet",
      "input",
      "latin",
      "letters"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🅰️",
    "name": "a",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆎",
    "name": "ab",
    "altNames": [],
    "keywords": [
      "ab button (blood type)",
      "blood type"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🅱️",
    "name": "b",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆑",
    "name": "cl",
    "altNames": [],
    "keywords": [
      "cl button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆒",
    "name": "cool",
    "altNames": [],
    "keywords": [
      "cool button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆓",
    "name": "free",
    "altNames": [],
    "keywords": [
      "free button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "ℹ️",
    "name": "information_source",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆔",
    "name": "id",
    "altNames": [],
    "keywords": [
      "id button",
      "identity"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "Ⓜ️",
    "name": "m",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆕",
    "name": "new",
    "altNames": [],
    "keywords": [
      "new button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆖",
    "name": "ng",
    "altNames": [],
    "keywords": [
      "ng button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🅾️",
    "name": "o2",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆗",
    "name": "ok",
    "altNames": [],
    "keywords": [
      "ok button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🅿️",
    "name": "parking",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆘",
    "name": "sos",
    "altNames": [],
    "keywords": [
      "help",
      "sos button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆙",
    "name": "up",
    "altNames": [],
    "keywords": [
      "mark",
      "up!",
      "up! button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🆚",
    "name": "vs",
    "altNames": [],
    "keywords": [
      "versus",
      "vs button"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈁",
    "name": "koko",
    "altNames": [],
    "keywords": [
      "“here”",
      "japanese",
      "japanese “here” button",
      "katakana",
      "ココ"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈂️",
    "name": "sa",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈷️",
    "name": "u6708",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈶",
    "name": "u6709",
    "altNames": [],
    "keywords": [
      "“not free of charge”",
      "ideograph",
      "japanese",
      "japanese “not free of charge” button",
      "有"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈯",
    "name": "u6307",
    "altNames": [],
    "keywords": [
      "“reserved”",
      "ideograph",
      "japanese",
      "japanese “reserved” button",
      "指"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🉐",
    "name": "ideograph_advantage",
    "altNames": [],
    "keywords": [
      "“bargain”",
      "japanese",
      "japanese “bargain” button",
      "得"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈹",
    "name": "u5272",
    "altNames": [],
    "keywords": [
      "“discount”",
      "ideograph",
      "japanese",
      "japanese “discount” button",
      "割"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈚",
    "name": "u7121",
    "altNames": [],
    "keywords": [
      "“free of charge”",
      "ideograph",
      "japanese",
      "japanese “free of charge” button",
      "無"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈲",
    "name": "u7981",
    "altNames": [],
    "keywords": [
      "“prohibited”",
      "ideograph",
      "japanese",
      "japanese “prohibited” button",
      "禁"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🉑",
    "name": "accept",
    "altNames": [],
    "keywords": [
      "“acceptable”",
      "ideograph",
      "japanese",
      "japanese “acceptable” button",
      "可"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈸",
    "name": "u7533",
    "altNames": [],
    "keywords": [
      "“application”",
      "ideograph",
      "japanese",
      "japanese “application” button",
      "申"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈴",
    "name": "u5408",
    "altNames": [],
    "keywords": [
      "“passing grade”",
      "ideograph",
      "japanese",
      "japanese “passing grade” button",
      "合"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈳",
    "name": "u7a7a",
    "altNames": [],
    "keywords": [
      "“vacancy”",
      "ideograph",
      "japanese",
      "japanese “vacancy” button",
      "空"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "㊗️",
    "name": "congratulations",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "㊙️",
    "name": "secret",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈺",
    "name": "u55b6",
    "altNames": [],
    "keywords": [
      "“open for business”",
      "ideograph",
      "japanese",
      "japanese “open for business” button",
      "営"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🈵",
    "name": "u6e80",
    "altNames": [],
    "keywords": [
      "“no vacancy”",
      "ideograph",
      "japanese",
      "japanese “no vacancy” button",
      "満"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔴",
    "name": "red_circle",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟠",
    "name": "large_orange_circle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟡",
    "name": "large_yellow_circle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟢",
    "name": "large_green_circle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔵",
    "name": "large_blue_circle",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟣",
    "name": "large_purple_circle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟤",
    "name": "large_brown_circle",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⚫",
    "name": "black_circle",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⚪",
    "name": "white_circle",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟥",
    "name": "large_red_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟧",
    "name": "large_orange_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟨",
    "name": "large_yellow_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟩",
    "name": "large_green_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟦",
    "name": "large_blue_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟪",
    "name": "large_purple_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🟫",
    "name": "large_brown_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⬛",
    "name": "black_large_square",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "⬜",
    "name": "white_large_square",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "◼️",
    "name": "black_medium_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "◻️",
    "name": "white_medium_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "◾",
    "name": "black_medium_small_square",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "◽",
    "name": "white_medium_small_square",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "▪️",
    "name": "black_small_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "▫️",
    "name": "white_small_square",
    "altNames": [],
    "keywords": [],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔶",
    "name": "large_orange_diamond",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔷",
    "name": "large_blue_diamond",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔸",
    "name": "small_orange_diamond",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔹",
    "name": "small_blue_diamond",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔺",
    "name": "small_red_triangle",
    "altNames": [],
    "keywords": [
      "geometric",
      "red triangle pointed up"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔻",
    "name": "small_red_triangle_down",
    "altNames": [],
    "keywords": [
      "geometric",
      "red triangle pointed down"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "💠",
    "name": "diamond_shape_with_a_dot_inside",
    "altNames": [],
    "keywords": [
      "comic",
      "diamond with a dot",
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔘",
    "name": "radio_button",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔳",
    "name": "white_square_button",
    "altNames": [],
    "keywords": [
      "geometric",
      "outlined"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🔲",
    "name": "black_square_button",
    "altNames": [],
    "keywords": [
      "geometric"
    ],
    "category": "symbols",
    "fitzpatrickScale": false
  },
  {
    "char": "🏁",
    "name": "checkered_flag",
    "altNames": [],
    "keywords": [
      "chequered",
      "chequered flag",
      "racing"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🚩",
    "name": "triangular_flag_on_post",
    "altNames": [],
    "keywords": [],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🎌",
    "name": "crossed_flags",
    "altNames": [],
    "keywords": [
      "celebration",
      "japanese"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏴",
    "name": "waving_black_flag",
    "altNames": [],
    "keywords": [],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏳️",
    "name": "waving_white_flag",
    "altNames": [],
    "keywords": [],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏳️‍🌈",
    "name": "rainbow-flag",
    "altNames": [],
    "keywords": [],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏴‍☠️",
    "name": "pirate_flag",
    "altNames": [],
    "keywords": [],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇨",
    "name": "flag-ac",
    "altNames": [],
    "keywords": [
      "flag: ascension island"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇩",
    "name": "flag-ad",
    "altNames": [],
    "keywords": [
      "flag: andorra"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇪",
    "name": "flag-ae",
    "altNames": [],
    "keywords": [
      "flag: united arab emirates"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇫",
    "name": "flag-af",
    "altNames": [],
    "keywords": [
      "flag: afghanistan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇬",
    "name": "flag-ag",
    "altNames": [],
    "keywords": [
      "flag: antigua & barbuda"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇮",
    "name": "flag-ai",
    "altNames": [],
    "keywords": [
      "flag: anguilla"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇱",
    "name": "flag-al",
    "altNames": [],
    "keywords": [
      "flag: albania"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇲",
    "name": "flag-am",
    "altNames": [],
    "keywords": [
      "flag: armenia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇴",
    "name": "flag-ao",
    "altNames": [],
    "keywords": [
      "flag: angola"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇶",
    "name": "flag-aq",
    "altNames": [],
    "keywords": [
      "flag: antarctica"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇷",
    "name": "flag-ar",
    "altNames": [],
    "keywords": [
      "flag: argentina"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇸",
    "name": "flag-as",
    "altNames": [],
    "keywords": [
      "flag: american samoa"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇹",
    "name": "flag-at",
    "altNames": [],
    "keywords": [
      "flag: austria"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇺",
    "name": "flag-au",
    "altNames": [],
    "keywords": [
      "flag: australia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇼",
    "name": "flag-aw",
    "altNames": [],
    "keywords": [
      "flag: aruba"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇽",
    "name": "flag-ax",
    "altNames": [],
    "keywords": [
      "flag: åland islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇦🇿",
    "name": "flag-az",
    "altNames": [],
    "keywords": [
      "flag: azerbaijan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇦",
    "name": "flag-ba",
    "altNames": [],
    "keywords": [
      "flag: bosnia & herzegovina"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇧",
    "name": "flag-bb",
    "altNames": [],
    "keywords": [
      "flag: barbados"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇩",
    "name": "flag-bd",
    "altNames": [],
    "keywords": [
      "flag: bangladesh"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇪",
    "name": "flag-be",
    "altNames": [],
    "keywords": [
      "flag: belgium"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇫",
    "name": "flag-bf",
    "altNames": [],
    "keywords": [
      "flag: burkina faso"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇬",
    "name": "flag-bg",
    "altNames": [],
    "keywords": [
      "flag: bulgaria"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇭",
    "name": "flag-bh",
    "altNames": [],
    "keywords": [
      "flag: bahrain"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇮",
    "name": "flag-bi",
    "altNames": [],
    "keywords": [
      "flag: burundi"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇯",
    "name": "flag-bj",
    "altNames": [],
    "keywords": [
      "flag: benin"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇱",
    "name": "flag-bl",
    "altNames": [],
    "keywords": [
      "flag: st. barthélemy"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇲",
    "name": "flag-bm",
    "altNames": [],
    "keywords": [
      "flag: bermuda"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇳",
    "name": "flag-bn",
    "altNames": [],
    "keywords": [
      "flag: brunei"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇴",
    "name": "flag-bo",
    "altNames": [],
    "keywords": [
      "flag: bolivia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇶",
    "name": "flag-bq",
    "altNames": [],
    "keywords": [
      "flag: caribbean netherlands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇷",
    "name": "flag-br",
    "altNames": [],
    "keywords": [
      "flag: brazil"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇸",
    "name": "flag-bs",
    "altNames": [],
    "keywords": [
      "flag: bahamas"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇹",
    "name": "flag-bt",
    "altNames": [],
    "keywords": [
      "flag: bhutan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇻",
    "name": "flag-bv",
    "altNames": [],
    "keywords": [
      "flag: bouvet island"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇼",
    "name": "flag-bw",
    "altNames": [],
    "keywords": [
      "flag: botswana"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇾",
    "name": "flag-by",
    "altNames": [],
    "keywords": [
      "flag: belarus"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇧🇿",
    "name": "flag-bz",
    "altNames": [],
    "keywords": [
      "flag: belize"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇦",
    "name": "flag-ca",
    "altNames": [],
    "keywords": [
      "flag: canada"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇨",
    "name": "flag-cc",
    "altNames": [],
    "keywords": [
      "flag: cocos (keeling) islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇩",
    "name": "flag-cd",
    "altNames": [],
    "keywords": [
      "flag: congo - kinshasa"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇫",
    "name": "flag-cf",
    "altNames": [],
    "keywords": [
      "flag: central african republic"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇬",
    "name": "flag-cg",
    "altNames": [],
    "keywords": [
      "flag: congo - brazzaville"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇭",
    "name": "flag-ch",
    "altNames": [],
    "keywords": [
      "flag: switzerland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇮",
    "name": "flag-ci",
    "altNames": [],
    "keywords": [
      "flag: côte d’ivoire"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇰",
    "name": "flag-ck",
    "altNames": [],
    "keywords": [
      "flag: cook islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇱",
    "name": "flag-cl",
    "altNames": [],
    "keywords": [
      "flag: chile"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇲",
    "name": "flag-cm",
    "altNames": [],
    "keywords": [
      "flag: cameroon"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇳",
    "name": "cn",
    "altNames": [
      "flag-cn"
    ],
    "keywords": [
      "flag: china"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇴",
    "name": "flag-co",
    "altNames": [],
    "keywords": [
      "flag: colombia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇵",
    "name": "flag-cp",
    "altNames": [],
    "keywords": [
      "flag: clipperton island"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇷",
    "name": "flag-cr",
    "altNames": [],
    "keywords": [
      "flag: costa rica"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇺",
    "name": "flag-cu",
    "altNames": [],
    "keywords": [
      "flag: cuba"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇻",
    "name": "flag-cv",
    "altNames": [],
    "keywords": [
      "flag: cape verde"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇼",
    "name": "flag-cw",
    "altNames": [],
    "keywords": [
      "flag: curaçao"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇽",
    "name": "flag-cx",
    "altNames": [],
    "keywords": [
      "flag: christmas island"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇾",
    "name": "flag-cy",
    "altNames": [],
    "keywords": [
      "flag: cyprus"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇨🇿",
    "name": "flag-cz",
    "altNames": [],
    "keywords": [
      "flag: czechia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇪",
    "name": "de",
    "altNames": [
      "flag-de"
    ],
    "keywords": [
      "flag: germany"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇬",
    "name": "flag-dg",
    "altNames": [],
    "keywords": [
      "flag: diego garcia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇯",
    "name": "flag-dj",
    "altNames": [],
    "keywords": [
      "flag: djibouti"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇰",
    "name": "flag-dk",
    "altNames": [],
    "keywords": [
      "flag: denmark"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇲",
    "name": "flag-dm",
    "altNames": [],
    "keywords": [
      "flag: dominica"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇴",
    "name": "flag-do",
    "altNames": [],
    "keywords": [
      "flag: dominican republic"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇩🇿",
    "name": "flag-dz",
    "altNames": [],
    "keywords": [
      "flag: algeria"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇦",
    "name": "flag-ea",
    "altNames": [],
    "keywords": [
      "flag: ceuta & melilla"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇨",
    "name": "flag-ec",
    "altNames": [],
    "keywords": [
      "flag: ecuador"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇪",
    "name": "flag-ee",
    "altNames": [],
    "keywords": [
      "flag: estonia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇬",
    "name": "flag-eg",
    "altNames": [],
    "keywords": [
      "flag: egypt"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇭",
    "name": "flag-eh",
    "altNames": [],
    "keywords": [
      "flag: western sahara"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇷",
    "name": "flag-er",
    "altNames": [],
    "keywords": [
      "flag: eritrea"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇸",
    "name": "es",
    "altNames": [
      "flag-es"
    ],
    "keywords": [
      "flag: spain"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇹",
    "name": "flag-et",
    "altNames": [],
    "keywords": [
      "flag: ethiopia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇪🇺",
    "name": "flag-eu",
    "altNames": [],
    "keywords": [
      "flag: european union"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇫🇮",
    "name": "flag-fi",
    "altNames": [],
    "keywords": [
      "flag: finland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇫🇯",
    "name": "flag-fj",
    "altNames": [],
    "keywords": [
      "flag: fiji"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇫🇰",
    "name": "flag-fk",
    "altNames": [],
    "keywords": [
      "flag: falkland islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇫🇲",
    "name": "flag-fm",
    "altNames": [],
    "keywords": [
      "flag: micronesia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇫🇴",
    "name": "flag-fo",
    "altNames": [],
    "keywords": [
      "flag: faroe islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇫🇷",
    "name": "fr",
    "altNames": [
      "flag-fr"
    ],
    "keywords": [
      "flag: france"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇦",
    "name": "flag-ga",
    "altNames": [],
    "keywords": [
      "flag: gabon"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇧",
    "name": "gb",
    "altNames": [
      "uk",
      "flag-gb"
    ],
    "keywords": [
      "flag: united kingdom"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇩",
    "name": "flag-gd",
    "altNames": [],
    "keywords": [
      "flag: grenada"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇪",
    "name": "flag-ge",
    "altNames": [],
    "keywords": [
      "flag: georgia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇫",
    "name": "flag-gf",
    "altNames": [],
    "keywords": [
      "flag: french guiana"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇬",
    "name": "flag-gg",
    "altNames": [],
    "keywords": [
      "flag: guernsey"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇭",
    "name": "flag-gh",
    "altNames": [],
    "keywords": [
      "flag: ghana"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇮",
    "name": "flag-gi",
    "altNames": [],
    "keywords": [
      "flag: gibraltar"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇱",
    "name": "flag-gl",
    "altNames": [],
    "keywords": [
      "flag: greenland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇲",
    "name": "flag-gm",
    "altNames": [],
    "keywords": [
      "flag: gambia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇳",
    "name": "flag-gn",
    "altNames": [],
    "keywords": [
      "flag: guinea"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇵",
    "name": "flag-gp",
    "altNames": [],
    "keywords": [
      "flag: guadeloupe"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇶",
    "name": "flag-gq",
    "altNames": [],
    "keywords": [
      "flag: equatorial guinea"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇷",
    "name": "flag-gr",
    "altNames": [],
    "keywords": [
      "flag: greece"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇸",
    "name": "flag-gs",
    "altNames": [],
    "keywords": [
      "flag: south georgia & south sandwich islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇹",
    "name": "flag-gt",
    "altNames": [],
    "keywords": [
      "flag: guatemala"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇺",
    "name": "flag-gu",
    "altNames": [],
    "keywords": [
      "flag: guam"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇼",
    "name": "flag-gw",
    "altNames": [],
    "keywords": [
      "flag: guinea-bissau"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇬🇾",
    "name": "flag-gy",
    "altNames": [],
    "keywords": [
      "flag: guyana"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇭🇰",
    "name": "flag-hk",
    "altNames": [],
    "keywords": [
      "flag: hong kong sar china"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇭🇲",
    "name": "flag-hm",
    "altNames": [],
    "keywords": [
      "flag: heard & mcdonald islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇭🇳",
    "name": "flag-hn",
    "altNames": [],
    "keywords": [
      "flag: honduras"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇭🇷",
    "name": "flag-hr",
    "altNames": [],
    "keywords": [
      "flag: croatia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇭🇹",
    "name": "flag-ht",
    "altNames": [],
    "keywords": [
      "flag: haiti"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇭🇺",
    "name": "flag-hu",
    "altNames": [],
    "keywords": [
      "flag: hungary"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇨",
    "name": "flag-ic",
    "altNames": [],
    "keywords": [
      "flag: canary islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇩",
    "name": "flag-id",
    "altNames": [],
    "keywords": [
      "flag: indonesia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇪",
    "name": "flag-ie",
    "altNames": [],
    "keywords": [
      "flag: ireland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇱",
    "name": "flag-il",
    "altNames": [],
    "keywords": [
      "flag: israel"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇲",
    "name": "flag-im",
    "altNames": [],
    "keywords": [
      "flag: isle of man"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇳",
    "name": "flag-in",
    "altNames": [],
    "keywords": [
      "flag: india"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇴",
    "name": "flag-io",
    "altNames": [],
    "keywords": [
      "flag: british indian ocean territory"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇶",
    "name": "flag-iq",
    "altNames": [],
    "keywords": [
      "flag: iraq"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇷",
    "name": "flag-ir",
    "altNames": [],
    "keywords": [
      "flag: iran"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇸",
    "name": "flag-is",
    "altNames": [],
    "keywords": [
      "flag: iceland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇮🇹",
    "name": "it",
    "altNames": [
      "flag-it"
    ],
    "keywords": [
      "flag: italy"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇯🇪",
    "name": "flag-je",
    "altNames": [],
    "keywords": [
      "flag: jersey"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇯🇲",
    "name": "flag-jm",
    "altNames": [],
    "keywords": [
      "flag: jamaica"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇯🇴",
    "name": "flag-jo",
    "altNames": [],
    "keywords": [
      "flag: jordan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇯🇵",
    "name": "jp",
    "altNames": [
      "flag-jp"
    ],
    "keywords": [
      "flag: japan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇪",
    "name": "flag-ke",
    "altNames": [],
    "keywords": [
      "flag: kenya"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇬",
    "name": "flag-kg",
    "altNames": [],
    "keywords": [
      "flag: kyrgyzstan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇭",
    "name": "flag-kh",
    "altNames": [],
    "keywords": [
      "flag: cambodia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇮",
    "name": "flag-ki",
    "altNames": [],
    "keywords": [
      "flag: kiribati"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇲",
    "name": "flag-km",
    "altNames": [],
    "keywords": [
      "flag: comoros"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇳",
    "name": "flag-kn",
    "altNames": [],
    "keywords": [
      "flag: st. kitts & nevis"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇵",
    "name": "flag-kp",
    "altNames": [],
    "keywords": [
      "flag: north korea"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇷",
    "name": "kr",
    "altNames": [
      "flag-kr"
    ],
    "keywords": [
      "flag: south korea"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇼",
    "name": "flag-kw",
    "altNames": [],
    "keywords": [
      "flag: kuwait"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇾",
    "name": "flag-ky",
    "altNames": [],
    "keywords": [
      "flag: cayman islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇰🇿",
    "name": "flag-kz",
    "altNames": [],
    "keywords": [
      "flag: kazakhstan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇦",
    "name": "flag-la",
    "altNames": [],
    "keywords": [
      "flag: laos"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇧",
    "name": "flag-lb",
    "altNames": [],
    "keywords": [
      "flag: lebanon"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇨",
    "name": "flag-lc",
    "altNames": [],
    "keywords": [
      "flag: st. lucia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇮",
    "name": "flag-li",
    "altNames": [],
    "keywords": [
      "flag: liechtenstein"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇰",
    "name": "flag-lk",
    "altNames": [],
    "keywords": [
      "flag: sri lanka"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇷",
    "name": "flag-lr",
    "altNames": [],
    "keywords": [
      "flag: liberia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇸",
    "name": "flag-ls",
    "altNames": [],
    "keywords": [
      "flag: lesotho"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇹",
    "name": "flag-lt",
    "altNames": [],
    "keywords": [
      "flag: lithuania"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇺",
    "name": "flag-lu",
    "altNames": [],
    "keywords": [
      "flag: luxembourg"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇻",
    "name": "flag-lv",
    "altNames": [],
    "keywords": [
      "flag: latvia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇱🇾",
    "name": "flag-ly",
    "altNames": [],
    "keywords": [
      "flag: libya"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇦",
    "name": "flag-ma",
    "altNames": [],
    "keywords": [
      "flag: morocco"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇨",
    "name": "flag-mc",
    "altNames": [],
    "keywords": [
      "flag: monaco"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇩",
    "name": "flag-md",
    "altNames": [],
    "keywords": [
      "flag: moldova"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇪",
    "name": "flag-me",
    "altNames": [],
    "keywords": [
      "flag: montenegro"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇫",
    "name": "flag-mf",
    "altNames": [],
    "keywords": [
      "flag: st. martin"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇬",
    "name": "flag-mg",
    "altNames": [],
    "keywords": [
      "flag: madagascar"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇭",
    "name": "flag-mh",
    "altNames": [],
    "keywords": [
      "flag: marshall islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇰",
    "name": "flag-mk",
    "altNames": [],
    "keywords": [
      "flag: north macedonia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇱",
    "name": "flag-ml",
    "altNames": [],
    "keywords": [
      "flag: mali"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇲",
    "name": "flag-mm",
    "altNames": [],
    "keywords": [
      "flag: myanmar (burma)"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇳",
    "name": "flag-mn",
    "altNames": [],
    "keywords": [
      "flag: mongolia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇴",
    "name": "flag-mo",
    "altNames": [],
    "keywords": [
      "flag: macao sar china"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇵",
    "name": "flag-mp",
    "altNames": [],
    "keywords": [
      "flag: northern mariana islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇶",
    "name": "flag-mq",
    "altNames": [],
    "keywords": [
      "flag: martinique"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇷",
    "name": "flag-mr",
    "altNames": [],
    "keywords": [
      "flag: mauritania"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇸",
    "name": "flag-ms",
    "altNames": [],
    "keywords": [
      "flag: montserrat"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇹",
    "name": "flag-mt",
    "altNames": [],
    "keywords": [
      "flag: malta"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇺",
    "name": "flag-mu",
    "altNames": [],
    "keywords": [
      "flag: mauritius"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇻",
    "name": "flag-mv",
    "altNames": [],
    "keywords": [
      "flag: maldives"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇼",
    "name": "flag-mw",
    "altNames": [],
    "keywords": [
      "flag: malawi"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇽",
    "name": "flag-mx",
    "altNames": [],
    "keywords": [
      "flag: mexico"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇾",
    "name": "flag-my",
    "altNames": [],
    "keywords": [
      "flag: malaysia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇲🇿",
    "name": "flag-mz",
    "altNames": [],
    "keywords": [
      "flag: mozambique"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇦",
    "name": "flag-na",
    "altNames": [],
    "keywords": [
      "flag: namibia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇨",
    "name": "flag-nc",
    "altNames": [],
    "keywords": [
      "flag: new caledonia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇪",
    "name": "flag-ne",
    "altNames": [],
    "keywords": [
      "flag: niger"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇫",
    "name": "flag-nf",
    "altNames": [],
    "keywords": [
      "flag: norfolk island"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇬",
    "name": "flag-ng",
    "altNames": [],
    "keywords": [
      "flag: nigeria"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇮",
    "name": "flag-ni",
    "altNames": [],
    "keywords": [
      "flag: nicaragua"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇱",
    "name": "flag-nl",
    "altNames": [],
    "keywords": [
      "flag: netherlands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇴",
    "name": "flag-no",
    "altNames": [],
    "keywords": [
      "flag: norway"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇵",
    "name": "flag-np",
    "altNames": [],
    "keywords": [
      "flag: nepal"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇷",
    "name": "flag-nr",
    "altNames": [],
    "keywords": [
      "flag: nauru"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇺",
    "name": "flag-nu",
    "altNames": [],
    "keywords": [
      "flag: niue"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇳🇿",
    "name": "flag-nz",
    "altNames": [],
    "keywords": [
      "flag: new zealand"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇴🇲",
    "name": "flag-om",
    "altNames": [],
    "keywords": [
      "flag: oman"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇦",
    "name": "flag-pa",
    "altNames": [],
    "keywords": [
      "flag: panama"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇪",
    "name": "flag-pe",
    "altNames": [],
    "keywords": [
      "flag: peru"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇫",
    "name": "flag-pf",
    "altNames": [],
    "keywords": [
      "flag: french polynesia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇬",
    "name": "flag-pg",
    "altNames": [],
    "keywords": [
      "flag: papua new guinea"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇭",
    "name": "flag-ph",
    "altNames": [],
    "keywords": [
      "flag: philippines"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇰",
    "name": "flag-pk",
    "altNames": [],
    "keywords": [
      "flag: pakistan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇱",
    "name": "flag-pl",
    "altNames": [],
    "keywords": [
      "flag: poland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇲",
    "name": "flag-pm",
    "altNames": [],
    "keywords": [
      "flag: st. pierre & miquelon"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇳",
    "name": "flag-pn",
    "altNames": [],
    "keywords": [
      "flag: pitcairn islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇷",
    "name": "flag-pr",
    "altNames": [],
    "keywords": [
      "flag: puerto rico"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇸",
    "name": "flag-ps",
    "altNames": [],
    "keywords": [
      "flag: palestinian territories"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇹",
    "name": "flag-pt",
    "altNames": [],
    "keywords": [
      "flag: portugal"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇼",
    "name": "flag-pw",
    "altNames": [],
    "keywords": [
      "flag: palau"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇵🇾",
    "name": "flag-py",
    "altNames": [],
    "keywords": [
      "flag: paraguay"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇶🇦",
    "name": "flag-qa",
    "altNames": [],
    "keywords": [
      "flag: qatar"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇷🇪",
    "name": "flag-re",
    "altNames": [],
    "keywords": [
      "flag: réunion"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇷🇴",
    "name": "flag-ro",
    "altNames": [],
    "keywords": [
      "flag: romania"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇷🇸",
    "name": "flag-rs",
    "altNames": [],
    "keywords": [
      "flag: serbia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇷🇺",
    "name": "ru",
    "altNames": [
      "flag-ru"
    ],
    "keywords": [
      "flag: russia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇷🇼",
    "name": "flag-rw",
    "altNames": [],
    "keywords": [
      "flag: rwanda"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇦",
    "name": "flag-sa",
    "altNames": [],
    "keywords": [
      "flag: saudi arabia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇧",
    "name": "flag-sb",
    "altNames": [],
    "keywords": [
      "flag: solomon islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇨",
    "name": "flag-sc",
    "altNames": [],
    "keywords": [
      "flag: seychelles"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇩",
    "name": "flag-sd",
    "altNames": [],
    "keywords": [
      "flag: sudan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇪",
    "name": "flag-se",
    "altNames": [],
    "keywords": [
      "flag: sweden"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇬",
    "name": "flag-sg",
    "altNames": [],
    "keywords": [
      "flag: singapore"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇭",
    "name": "flag-sh",
    "altNames": [],
    "keywords": [
      "flag: st. helena"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇮",
    "name": "flag-si",
    "altNames": [],
    "keywords": [
      "flag: slovenia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇯",
    "name": "flag-sj",
    "altNames": [],
    "keywords": [
      "flag: svalbard & jan mayen"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇰",
    "name": "flag-sk",
    "altNames": [],
    "keywords": [
      "flag: slovakia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇱",
    "name": "flag-sl",
    "altNames": [],
    "keywords": [
      "flag: sierra leone"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇲",
    "name": "flag-sm",
    "altNames": [],
    "keywords": [
      "flag: san marino"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇳",
    "name": "flag-sn",
    "altNames": [],
    "keywords": [
      "flag: senegal"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇴",
    "name": "flag-so",
    "altNames": [],
    "keywords": [
      "flag: somalia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇷",
    "name": "flag-sr",
    "altNames": [],
    "keywords": [
      "flag: suriname"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇸",
    "name": "flag-ss",
    "altNames": [],
    "keywords": [
      "flag: south sudan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇹",
    "name": "flag-st",
    "altNames": [],
    "keywords": [
      "flag: são tomé & príncipe"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇻",
    "name": "flag-sv",
    "altNames": [],
    "keywords": [
      "flag: el salvador"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇽",
    "name": "flag-sx",
    "altNames": [],
    "keywords": [
      "flag: sint maarten"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇾",
    "name": "flag-sy",
    "altNames": [],
    "keywords": [
      "flag: syria"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇸🇿",
    "name": "flag-sz",
    "altNames": [],
    "keywords": [
      "flag: eswatini"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇦",
    "name": "flag-ta",
    "altNames": [],
    "keywords": [
      "flag: tristan da cunha"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇨",
    "name": "flag-tc",
    "altNames": [],
    "keywords": [
      "flag: turks & caicos islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇩",
    "name": "flag-td",
    "altNames": [],
    "keywords": [
      "flag: chad"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇫",
    "name": "flag-tf",
    "altNames": [],
    "keywords": [
      "flag: french southern territories"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇬",
    "name": "flag-tg",
    "altNames": [],
    "keywords": [
      "flag: togo"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇭",
    "name": "flag-th",
    "altNames": [],
    "keywords": [
      "flag: thailand"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇯",
    "name": "flag-tj",
    "altNames": [],
    "keywords": [
      "flag: tajikistan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇰",
    "name": "flag-tk",
    "altNames": [],
    "keywords": [
      "flag: tokelau"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇱",
    "name": "flag-tl",
    "altNames": [],
    "keywords": [
      "flag: timor-leste"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇲",
    "name": "flag-tm",
    "altNames": [],
    "keywords": [
      "flag: turkmenistan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇳",
    "name": "flag-tn",
    "altNames": [],
    "keywords": [
      "flag: tunisia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇴",
    "name": "flag-to",
    "altNames": [],
    "keywords": [
      "flag: tonga"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇷",
    "name": "flag-tr",
    "altNames": [],
    "keywords": [
      "flag: türkiye"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇹",
    "name": "flag-tt",
    "altNames": [],
    "keywords": [
      "flag: trinidad & tobago"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇻",
    "name": "flag-tv",
    "altNames": [],
    "keywords": [
      "flag: tuvalu"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇼",
    "name": "flag-tw",
    "altNames": [],
    "keywords": [
      "flag: taiwan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇹🇿",
    "name": "flag-tz",
    "altNames": [],
    "keywords": [
      "flag: tanzania"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇦",
    "name": "flag-ua",
    "altNames": [],
    "keywords": [
      "flag: ukraine"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇬",
    "name": "flag-ug",
    "altNames": [],
    "keywords": [
      "flag: uganda"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇲",
    "name": "flag-um",
    "altNames": [],
    "keywords": [
      "flag: u.s. outlying islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇳",
    "name": "flag-un",
    "altNames": [],
    "keywords": [
      "flag: united nations"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇸",
    "name": "us",
    "altNames": [
      "flag-us"
    ],
    "keywords": [
      "flag: united states"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇾",
    "name": "flag-uy",
    "altNames": [],
    "keywords": [
      "flag: uruguay"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇺🇿",
    "name": "flag-uz",
    "altNames": [],
    "keywords": [
      "flag: uzbekistan"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇦",
    "name": "flag-va",
    "altNames": [],
    "keywords": [
      "flag: vatican city"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇨",
    "name": "flag-vc",
    "altNames": [],
    "keywords": [
      "flag: st. vincent & grenadines"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇪",
    "name": "flag-ve",
    "altNames": [],
    "keywords": [
      "flag: venezuela"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇬",
    "name": "flag-vg",
    "altNames": [],
    "keywords": [
      "flag: british virgin islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇮",
    "name": "flag-vi",
    "altNames": [],
    "keywords": [
      "flag: u.s. virgin islands"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇳",
    "name": "flag-vn",
    "altNames": [],
    "keywords": [
      "flag: vietnam"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇻🇺",
    "name": "flag-vu",
    "altNames": [],
    "keywords": [
      "flag: vanuatu"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇼🇫",
    "name": "flag-wf",
    "altNames": [],
    "keywords": [
      "flag: wallis & futuna"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇼🇸",
    "name": "flag-ws",
    "altNames": [],
    "keywords": [
      "flag: samoa"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇽🇰",
    "name": "flag-xk",
    "altNames": [],
    "keywords": [
      "flag: kosovo"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇾🇪",
    "name": "flag-ye",
    "altNames": [],
    "keywords": [
      "flag: yemen"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇾🇹",
    "name": "flag-yt",
    "altNames": [],
    "keywords": [
      "flag: mayotte"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇿🇦",
    "name": "flag-za",
    "altNames": [],
    "keywords": [
      "flag: south africa"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇿🇲",
    "name": "flag-zm",
    "altNames": [],
    "keywords": [
      "flag: zambia"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🇿🇼",
    "name": "flag-zw",
    "altNames": [],
    "keywords": [
      "flag: zimbabwe"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    "name": "flag-england",
    "altNames": [],
    "keywords": [
      "flag: england"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    "name": "flag-scotland",
    "altNames": [],
    "keywords": [
      "flag: scotland"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  },
  {
    "char": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    "name": "flag-wales",
    "altNames": [],
    "keywords": [
      "flag: wales"
    ],
    "category": "flags",
    "fitzpatrickScale": false
  }
] as const;

export default emojis;

